(function() {
  'use strict';

  angular
    .module('vmsFrontend', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
      'LocalStorageModule', 'ui.router', 'ui.bootstrap', 'toastr', 'angular-jwt', 'naif.base64',
      'angular-loading-bar', 'anim-in-out', 'xeditable', 'ngTagsInput', 'ngLodash', 'froala',
      'pascalprecht.translate', 'validation.match', 'vmsFrontend.config'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserEditSkillEquipmentController', UserEditSkillEquipmentController);

  function UserEditSkillEquipmentController(userEquipment, userSkill, arrayHelpersService, $scope, $log) {
    var vm = this;
    vm.equipment = [];
    vm.skills = [];
    vm.skillCandidatedKeywords = [];
    vm.equipmentCandidatedKeywords = [];
    $scope.originSkills = [];
    $scope.originEquipment = [];

    angular.element(document).ready(getSkills);
    angular.element(document).ready(getEquipment);

    function getSkills() {
      var onSuccess = function(value) {
        $log.debug(value.skills);

        vm.skills = value.skills;
        $scope.originSkills = angular.copy(value.skills);

        $log.debug('### $scope.originSkills ###');
        $log.debug($scope.originSkills);
      };

      var onFailure = function(data) {
        /**
         * TODO: show error msg
         */
      };

      userSkill.getAll()
        .then(onSuccess)
        .catch(onFailure);
    }

    function getEquipment() {
      var onSuccess = function(value) {
        $log.debug(value.equipment);

        vm.equipment = value.equipment;
        $scope.equipment = angular.copy(value.equipment);

        $log.debug('### $scope.equipment ###');
        $log.debug($scope.equipment);
      };

      var onFailure = function(data) {
        /**
         * TODO: show error msg
         */
      };

      userEquipment
        .getAll()
        .then(onSuccess)
        .catch(onFailure);
    }

    vm.refreshSkillCandidatedKeywords = function(skill) {
      $log.debug('search skill keyword');
      $log.debug(skill);

      var onSuccess = function(result) {
        $log.debug('refreshSkillCandidatedKeywords onSuccess()');
        $log.debug(result);
        return result;
      };

      return userSkill
        .getCandidatedKeywords(skill)
        .then(onSuccess);
    };

    vm.refreshEquipmentCandidateKeywords = function(equipment) {
      $log.debug('search equipment keyword');
      $log.debug(equipment);

      var onSuccess = function(result) {
        $log.debug('refreshEquipmentCandidateKeywords onSuccess()');
        $log.debug(result);
        return result;
      };

      return userEquipment
        .getCandidatedKeywords(equipment)
        .then(onSuccess);
    };

    vm.updateSkills = function() {
      $log.debug('updateSkills()');
      $log.debug(vm.skills);

      var onSuccess = function() {
        getSkills();
      };
      var onFailure = function(data) {
        /**
         * TODO: show error msg
         */
      };

      $log.debug('$scope.originSkills');
      $log.debug($scope.originSkills);

      $log.debug('vm.skills');
      $log.debug(vm.skills);

      var existingIndexes = arrayHelpersService.getExistingIndexes($scope.originSkills, vm.skills);

      $log.debug('existingIndexes');
      $log.debug(existingIndexes);

      userSkill
        .update(vm.skills, existingIndexes)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.updateEquipment = function() {
      $log.debug('updateEquipment()');
      $log.debug(vm.equipment);

      var onSuccess = function() {
        getSkills();
      };
      var onFailure = function(data) {
        /**
         * TODO: show error msg
         */
      };

      $log.debug('$scope.originEquipment');
      $log.debug($scope.originEquipment);

      var existingIndexes = arrayHelpersService.getExistingIndexes($scope.originEquipment, vm.equipment);

      $log.debug('existingIndexes');
      $log.debug(existingIndexes);

      userEquipment
        .update(vm.equipment, existingIndexes)
        .then(onSuccess)
        .catch(onFailure);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserRegisterSuccessController', UserRegisterSuccessController);

  /** @ngInject */
  function UserRegisterSuccessController($log, $location) {
    var vm = this;
    vm.volunteer = $location.search();
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UpdateUserProfileController', UpdateUserProfileController);

  /** @ngInject */
  function UpdateUserProfileController(
    $log,
    userProfile,
    cities
  ) {
    var vm = this;
    vm.cities = cities;

    vm.datePicker = {
      mode: 'year',
      dateOptions: {
        datepickerMode: 'year',
        minMode: "'year'",
        // minDate: "minDate",
        showWeeks: "false"
      },
      status: {
        opened: false
      },
      format: 'yyyy'
    };

    vm.openDatePicker = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.datePicker.status.opened = true;
    };

    // In the begining, it gets the volunteer's profile
    angular.element(document).ready(getProfile());

    function getProfile() {
      var doneCallbacks = function(value) {
          vm.profile = value.data;

          $log.debug(vm.profile);
        },
        failCallbacks = function(response) {
          $log.debug(response);
        };

      userProfile
        .get()
        .then(doneCallbacks, failCallbacks);
    }

    vm.updateAboutAndContact = function() {
      var onSuccess = function(value) {
        $log.debug(value);
        vm.profile = value.data;

        vm.alert = [];
        vm.alert.push({
          type: 'success',
          data: {
            message: 'alert.success.updated_successfully'
          }
        });
      };

      $log.debug(vm.profile);

      userProfile
        .update(vm.profile)
        .then(onSuccess);
    };

    vm.selectAvatar = function(event, fileReader, file, fileList, fileObjects, object) {
      var base64Image = "data:" + object.filetype + ';base64,' + object.base64;

      userProfile
        .updateAvatar(base64Image, true)
        .then(function(value) {
          var data = value.data;

          vm.profile.avatar_url = data.avatar_url;
        })

      vm.avatar = base64Image;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ShowUserProfileController', ShowUserProfileController);

  /** @ngInject */

  function ShowUserProfileController($uibModal, cities, $log, defaultAvatarPath, userProfile) {

    var vm = this;

    vm.open = function() {
      var modal = $uibModal.open({
        templateUrl: 'myModalContent.html',
        controller: 'ModalInstanceCtrl',
        controllerAs: 'vm'
      });
    };

    angular.element(document).ready(getProfile());

    function getProfile() {
      var doneCallbacks = function(result) {
          $log.debug("getProfile() done");
          $log.debug(result);

          vm.profile = result.data;
        },
        failCallbacks = function(response) {
          $log.debug(response);
        };

      userProfile.get().then(doneCallbacks, failCallbacks)
    }
  }

  angular.module('vmsFrontend').controller('ModalInstanceCtrl', function($state, $uibModalInstance, $log, vmsLocalStorage, userProfile) {

    var vm = this;
    vm.remind = "提醒您，帳號刪除後無法再還原，如果您確定要刪除帳號。";

    vm.ok = function() {
      $log.debug('deleteClickOk');

      var credentials = {
        username: vmsLocalStorage.getUsername(),
        password: vm.password
      };

      $log.debug("username = " + credentials.username);
      $log.debug("password = " + credentials.password);

      userProfile
        .drop(credentials)
        .then(function(response) {
          $log.debug("delete success");
          $uibModalInstance.close();

          $state.go('login');
        })
        .catch(function(response) {
          $log.debug("delete failure");
          $log.debug(response);

          if (response.status == 401) {
            vm.deleteMsg = "您的密碼輸入錯誤，請重新輸入";
          }
        });
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('VerifyUserEmailController', VerifyUserEmailController);

  /** @ngInject */
  function VerifyUserEmailController($log, $location, vmsClient, authPrinciple, $state, $rootScope, $timeout) {
    var vm = this;
    vm.verification = true;
    vm.verificationSuccess = false;
    vm.verificationStatus = vm.verification || vm.verificationSuccess;

    $log.debug("vm.verification " + vm.verification);
    $log.debug("vm.verificationSuccess " + vm.verificationSuccess);
    $log.debug("vm.verificationStatus " + vm.verificationStatus);

    vm.volunteer = $location.search();

    if (angular.isDefined(vm.volunteer.email) && angular.isDefined(vm.volunteer.verification_token)) {

      angular.element(document).ready(verify());
    } else {
      $log.debug("verification false");
      vm.verification = false;
      vm.verificationStatus = vm.verification || vm.verificationSuccess;

      $log.debug("vm.verificationStatus " + vm.verificationStatus);
    }

    function verify() {
      $log.debug("EmailVerificationController verify()");

      $log.debug("email = " + vm.volunteer.email);
      $log.debug("verification_token = " + vm.volunteer.verification_token);

      var successCallback = function(response) {
        $log.debug('emailVerification success');
        $log.debug(response);

        vm.verification = false;
        vm.verificationSuccess = true;
        vm.verificationStatus = vm.verification || vm.verificationSuccess;

        $timeout(function() {
          $state.go('profile')
        }, 5000);
      };

      var failureCallback = function(response) {
        $log.debug('emailVerification error');
        $log.debug(response);

        vm.verification = false;
        vm.verificationStatus = vm.verification || vm.verificationSuccess;
      };

      vmsClient.emailVerification(vm.volunteer.email,
        vm.volunteer.verification_token)
        .then(successCallback)
        .catch(failureCallback);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ProjectMemberListController', ProjectMemberListController);

  /** @ngInject */
  function ProjectMemberListController(
    $log,
    membersData,
    vmsClient
  ) {
    var vm = this;
    var customFields = membersData.data.custom_fields.data;
    vm.getCustomFieldById = getCustomFieldById;

    vm.members = membersData.data.members.data;

    $log.debug('vm.members');

    $log.debug(vm.members);

    function getCustomFieldById(id) {
      var customField;
      angular.forEach(customFields, function(item, key) {
        if (item.id == id) {
          customField = item;
        }
      });

      $log.debug('getCustomFieldById');
      $log.debug(customField);

      return customField;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ManagedProjectListController', ManagedProjectListController);

  /** @ngInject */
  function ManagedProjectListController($log, $uibModal, vmsClient, project) {
    var vm = this;

    angular.element(document).ready(getProjects());

    function getProjects() {
      var onSuccess = function(response) {
        vm.projects = response.data;
      };
      var onFailure = function() {};

      project
        .getManagedProjectList()
        .then(function(value) {
          $log.debug(value);
          vm.projects = value.data;
        })
        .catch(function(alert) {
          vm.alert = alert;
        });
    }

    // Modal
    vm.delete = function(projectId) {
      vm.deletedProjectId = projectId;

      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'deleteProject.html',
        controller: function($uibModalInstance) {
          var vm = this;

          vm.remind = '提醒您，帳號刪除後無法再還原，如果您確定要刪除帳號。';
          vm.ok = function() {
            $log.debug('=== ok ===');
          };
          vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'vm'
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('AttendingProjectListController', AttendingProjectListController);

  /** @ngInject */
  function AttendingProjectListController($log, vmsClient) {
    var vm = this;

    angular.element(document).ready(getProjects());

    function getProjects() {
      var onSuccess = function(response) {
        vm.projects = response.data;
      };
      var onFailure = function() {};

      vmsClient.getAttendingProject()
        .then(onSuccess).catch(onFailure);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('AllProjectListController', AllProjectListController);

  /** @ngInject */
  function AllProjectListController($log, projects) {
    var vm = this;
    vm.setSearchField = setSearchField;

    vm.searchField = 'name';
    vm.projects = projects;

    function setSearchField(field) {
      vm.searchProject = undefined;
      vm.searchField = field;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ManagedProjectDetailController', ManagedProjectDetailController);

  /** @ngInject */
  function ManagedProjectDetailController($log, $uibModal, vmsClient, projectData, members, PERMISSION_OPTIONS, $sce) {
    var vm = this;
    vm.permissionOptions = PERMISSION_OPTIONS;
    vm.project = projectData.data;
    vm.membersList = members;

    vm.attend = function() {
      var onSuccess = function(response) {
        $log.debug('attendProject() success');
      };
      var onFailure = function(response) {
        $log.debug('attendProject() failure');
      }

      vmsClient.attendProject(projectId)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.trustAsHtml = function(html) {
      return $sce.trustAsHtml(html);
    };

    vm.showMember = function(member) {
      $log.debug("showMemeber");
      $log.debug(member);

      var templateString = '<div class="modal-header"><h4>{{ vm.member.attributes.username }} 已參加的專案</h4></div>' +
        '<div class="modal-body"><show-attending-projects member-id="vm.member.id"></show-attending-projects></div>'

      $uibModal.open({
        animation: true,
        template: templateString,
        controller: function(member) {
          $log.debug("modal Controller");

          var vm = this;
          vm.member = member;

          $log.debug("vm.member");
          $log.debug(vm.member);
        },
        controllerAs: 'vm',
        resolve: {
          member: function() {
            return member;
          }
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ProjectDetailController', ProjectDetailController);

  /** @ngInject */
  function ProjectDetailController(
    $log,
    $state,
    $stateParams,
    vmsClient,
    project,
    PERMISSION_OPTIONS) {
    var vm = this;
    vm.permissionOptions = PERMISSION_OPTIONS;

    vm.projectId = $stateParams.id;

    angular.element(document).ready(getProject(vm.projectId));
    angular.element(document).ready(getProjectMembers(vm.projectId));

    vm.isGuest = function() {
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'guest';
      }

      return false;
    };

    vm.isCreator = function() {
      $log.debug('isCreator()');
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'creator';
      }

      return false;
    };

    vm.isMember = function() {
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'member';
      }

      return false;
    }

    vm.attend = function() {
      var onSuccess = function(response) {
        $log.debug('attendProject() success');
        $state.reload();
      };
      var onFailure = function(response) {
        $log.debug('attendProject() failure');
      }

      vmsClient.attendProject(vm.projectId)
        .then(onSuccess)
        .catch(onFailure);
    }

    function getProject(id) {
      $log.debug("getProject()");

      var onSuccess = function(value) {
        vm.project = value.data;
        vm.meta = value.meta;
      };
      var onFailure = function(response) {
        $log.debug(response);
      };

      project
        .getById(id)
        .then(onSuccess)
        .catch(onFailure);
    }

    function getProjectMembers(id) {
      var onSuccess = function(response) {
        vm.membersList = response.data;
        $log.debug(response.data);
      };
      var onFailure = function(response) {
        $log.debug(response);
      };

      vmsClient.getProjectMembers(id)
        .then(onSuccess)
        .catch(onFailure);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ManageProjectCustomFieldsController', ManageProjectCustomFieldsController);

  /** @ngInject */
  function ManageProjectCustomFieldsController(
    $log,
    $stateParams,
    $uibModal,
    projectCustomField
  ) {
    var vm = this;
    var projectId = $stateParams.projectId;

    angular.element(document).ready(getProjectCustomFields);

    vm.preview = preview;
    vm.appendCustomField = appendCustomField;

    function getProjectCustomFields() {
      projectCustomField
        .getAllByProjectId(projectId)
        .then(function(value) {
          if (value.data.length == 0) {
            vm.alerts = [
              {
                type: 'info',
                data: {
                  message: 'alert.info.non_custom_field'
                }
              }
            ];
          }

          vm.customFields = value.data;
        })
        .catch(function(alert) {
          vm.alerts = [];
          vm.alerts.push(alert);
        });
    }

    function appendCustomField() {
      vm.alerts = [];
      vm.customFields.push({
        order: vm.customFields.length
      });
    }

    function preview(data) {
      var modal = $uibModal.open({
        animation: true,
        templateUrl: 'customFieldPreview.html',
        controller: function($uibModalInstance) {
          var vm = this;
          vm.data = data;
          vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        },
        controllerAs: 'vm'
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('FillCustomFieldsController', FillCustomFieldsController);

  /** @ngInject */
  function FillCustomFieldsController(
    $log,
    $stateParams,
    projectCustomField
  ) {
    var vm = this;
    var projectId = $stateParams.projectId;

    angular.element(document).ready(init);

    function init() {
      projectCustomField
        .getMemberDataByProjectId(projectId)
        .then(function(value) {
          vm.data = value.data
        })
        .catch(function(alert) {
          vm.alert = [alert];
        });
    }

    vm.update = function() {
      $log.debug('=== vm.update() ===');
      $log.debug(vm.data);

      var updatedData = [];

      angular.forEach(vm.data, function(item) {
        $log.debug(item);

        var value = item.custom_field_data;

        if (value != null) {
          $log.debug('value');
          $log.debug(value);

          delete value.created_at;
          delete value.updated_at;

          value['custom_field_id'] = item.id;
        }

        this.push(value);
      }, updatedData);

      $log.debug(updatedData);

      var onSuccess = function(response) {
        $log.debug(response);
        vm.msg = '已成功送出。'
      };
      var onFailure = function(response) {
        $log.debug(response);
      };

      projectCustomField
        .storeOrUpdateMemberDataByProjectId(updatedData, projectId)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.remove = function() {};
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('customFieldPreview', customFieldPreview);

  /** @ngInject */
  function customFieldPreview($compile) {
    var directive = {
      templateUrl: 'app/components/customField/preview/customFieldPreview.html',
      restrict: 'E',
      scope: {
        data: '='
      },
      controller: CustomFieldPreviewController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CustomFieldPreviewController(
      $log
    ) {
      var vm = this;
      $log.debug('CustomFieldPreviewController');
      $log.debug(vm.data);
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userSkillEndpoint', userSkillEndpoint);

  /** @ngInject */
  function userSkillEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      getAll: getAll,
      update: update,
      getCandidatedKeywords: getCandidatedKeywords
    };

    return service;

    function getAll() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/skills',
      });
    }

    function update(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/skills',
        data: data
      });
    }

    function getCandidatedKeywords(keyword) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/skill_candidates/' + keyword
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userSkill', userSkill);

  /** @ngInject */
  function userSkill($log, $q, userSkillEndpoint) {
    var service = {
      getAll: getAll,
      update: update,
      getCandidatedKeywords: getCandidatedKeywords
    };

    return service;

    function getAll() {
      var deferred = $q.defer();

      userSkillEndpoint
        .getAll()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.resolve(response.data);
        });

      return deferred.promise;
    }

    function update(values, existingIndexes) {
      var deferred = $q.defer();

      var skills = [];

      angular.forEach(values, function(value) {
        skills.push(value.name);
      });

      var data = {
        'skills': skills,
        'existing_skill_indexes': existingIndexes
      };

      userSkillEndpoint
        .update(data)
        .then(function(response) {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getCandidatedKeywords(keyword) {
      var deferred = $q.defer();

      userSkillEndpoint
        .getCandidatedKeywords(keyword)
        .then(function(response) {
          deferred.resolve(response.data.result);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userPasswordEndpoint', userPasswordEndpoint);

  /** @ngInject */
  function userPasswordEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      update: update,
      forgotPassword: forgotPassword,
      verifyPasswordReset: verifyPasswordReset,
      resetPassword: resetPassword
    };

    return service;

    function update(data) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me/password',
        data: data
      });
    }

    function forgotPassword(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/forgot_password',
        data: data
      });
    }

    function verifyPasswordReset(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/password_reset/verify',
        data: data
      });
    }

    function resetPassword(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/password_reset',
        data: data
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userPassword', userPassword);

  /** @ngInject */
  function userPassword(
    $log,
    $q,
    userPasswordEndpoint,
    alertMessage
  ) {
    var service = {
      update: update,
      forgotPassword: forgotPassword,
      verifyPasswordReset: verifyPasswordReset,
      resetPassword: resetPassword
    };

    return service;

    function update(password, newPassword) {
      var deferred = $q.defer();
      var data = {
        original_password: password,
        new_password: newPassword
      };

      userPasswordEndpoint
        .update(data)
        .then(function(response) {
          deferred.resolve();
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function forgotPassword(data) {
      var deferred = $q.defer();

      userPasswordEndpoint
        .forgotPassword(data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function verifyPasswordReset(email, token) {
      var deferred = $q.defer();
      var data = {
        email: email,
        token: token
      };

      userPasswordEndpoint
        .verifyPasswordReset(data)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function resetPassword(email, token, password, passwordConfirmation) {
      var deferred = $q.defer();
      var data = {
        email: email,
        token: token,
        password: password,
        password_confirmation: passwordConfirmation
      };

      userPasswordEndpoint
        .resetPassword(data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userProfileEndpoint', userProfileEndpoint);

  /** @ngInject */
  function userProfileEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      create: create,
      get: get,
      update: update,
      updateAvatar: updateAvatar,
      drop: drop,
      getAttendingProjects: getAttendingProjects,
      passwordReset: passwordReset
    };

    return service;

    function create(user) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/register',
        data: user
      });
    }

    function get() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me'
      });
    }

    function update(data) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me',
        data: data
      });
    }

    function updateAvatar(avatar, skipProfile) {
      var data = {
        avatar: avatar,
        skip_profile: skipProfile
      };

      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/avatar',
        data: data
      });
    }

    function drop(credentials) {
      /**
       * @TODO: change the POST action into DELETE (?)
       */
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/delete',
        data: credentials
      });
    }

    function getAttendingProjects(id) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/' + id + '/attending_projects'
      });
    }

    function passwordReset(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/forgot_password',
        data: data
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userProfile', userProfile);

  /** @ngInject */
  function userProfile(
    $log,
    $q,
    userProfileEndpoint,
    userAuthentication,
    vmsLocalStorage,
    alertMessage
  ) {
    var service = {
      create: create,
      get: get,
      update: update,
      updateAvatar: updateAvatar,
      drop: drop,
      getAttendingProjects: getAttendingProjects,
      forgotPassword: forgotPassword
    };

    $log.debug('userProfile');

    return service;

    function create(user, role) {
      var deferred = $q.defer();

      userProfileEndpoint
        .create(user)
        .then(function(response) {
          var value = response.data;
          var jsonWebToken = response.headers('Authorization');

          $log.debug(value);

          userAuthentication
            .setAuthentication(value.data, jsonWebToken, role);

          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts = alertMessage.convertToValidationDanger(errors);

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function get() {
      var deferred = $q.defer();

      userProfileEndpoint
        .get()
        .then(function(response) {
          var value = response.data;
          var year = value.data.birth_year;
          value.data.birth_year = new Date(year, 1);

          deferred.resolve(value);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function update(data) {
      var deferred = $q.defer();

      if (data.birth_year instanceof Date) {
        var date = data.birth_year;
        data.birth_year = date.getFullYear();
      }

      userProfileEndpoint
        .update(data)
        .then(function(response) {
          var value = response.data;
          var year = value.data.birth_year;
          value.data.birth_year = new Date(year, 1);

          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function updateAvatar(avatar, skipProfile) {
      var deferred = $q.defer();

      userProfileEndpoint
        .updateAvatar(avatar, skipProfile)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {});

      return deferred.promise;
    }

    function drop(credentials) {
      var deferred = $q.defer();

      userProfileEndpoint
        .drop(credentials)
        .then(function(response) {
          userAuthentication
            .logout();

          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getAttendingProjects(id) {
      var deferred = $q.defer();

      userProfileEndpoint
        .getAttendingProjects(id)
        .then(function(response) {
          deferred.resolve(response.data.data);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function forgotPassword(data) {

      $log.debug("forgotPassword data");
      $log.debug(data);

      var deferred = $q.defer();

      userProfileEndpoint
        .passwordReset(data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts = alertMessage.convertToValidationDanger(errors);

          deferred.reject(alerts);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userExperienceEndpoint', userExperienceEndpoint);

  /** @ngInject */
  function userExperienceEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      create: create,
      getAll: getAll,
      update: update,
      dropById: dropById,
    };

    return service;

    function create(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/experiences',
        data: data
      });
    }

    function getAll() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/experiences',
      });
    }

    function update(data) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me/experiences',
        data: data
      });
    }

    function dropById(id) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/users/me/experiences/' + id
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userExperience', userExperience);

  /** @ngInject */
  function userExperience($log, $q, userExperienceEndpoint) {
    var service = {
      create: create,
      getAll: getAll,
      update: update,
      dropById: dropById,
    };

    return service;

    function create(data) {
      var deferred = $q.defer();

      userExperienceEndpoint
        .create(data)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getAll() {
      var deferred = $q.defer();

      userExperienceEndpoint
        .getAll()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function update(data) {
      var deferred = $q.defer();

      userExperienceEndpoint
        .update(data)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function dropById(id) {
      var deferred = $q.defer();

      userExperienceEndpoint
        .dropById(id)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userEquipmentEndpoint', userEquipmentEndpoint);

  /** @ngInject */
  function userEquipmentEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      getAll: getAll,
      update: update,
      getCandidatedKeywords: getCandidatedKeywords
    };

    return service;

    function getAll() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/equipment',
      });
    }

    function update(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/equipment',
        data: data
      });
    }

    function getCandidatedKeywords(keyword) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/equipment_candidates/' + keyword
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userEquipment', userEquipment);

  /** @ngInject */
  function userEquipment($log, $q, userEquipmentEndpoint) {
    var service = {
      getAll: getAll,
      update: update,
      getCandidatedKeywords: getCandidatedKeywords
    };

    return service;

    function getAll() {
      var deferred = $q.defer();

      userEquipmentEndpoint
        .getAll()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.resolve(response.data);
        });

      return deferred.promise;
    }

    function update(values, existingIndexes) {
      var deferred = $q.defer();

      var equipment = [];

      angular.forEach(values, function(value) {
        equipment.push(value.name);
      });

      var data = {
        'equipment': equipment,
        'existing_equipment_indexes': existingIndexes
      };

      userEquipmentEndpoint
        .update(data)
        .then(function(response) {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getCandidatedKeywords(keyword) {
      var deferred = $q.defer();

      userEquipmentEndpoint
        .getCandidatedKeywords(keyword)
        .then(function(response) {
          deferred.resolve(response.data.result);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userEducationEndpoint', userEducationEndpoint);

  /** @ngInject */
  function userEducationEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      create: create,
      getAll: getAll,
      update: update,
      dropById: dropById,
    };

    return service;

    function create(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/educations',
        data: data
      });
    }

    function getAll() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/educations',
      });
    }

    function update(data) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me/educations',
        data: data
      });
    }

    function dropById(id) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/users/me/educations/' + educationId
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userEducation', userEducation);

  /** @ngInject */
  function userEducation($log, $q, userEducationEndpoint) {
    var service = {
      create: create,
      getAll: getAll,
      update: update,
      dropById: dropById,
    };

    return service;

    function create(data) {
      var deferred = $q.defer();

      userEducationEndpoint
        .create(data)
        .then(function(response) {
          $log.debug('create an education successfully');

          deferred.resolve(response.data);
        })
        .catch(function(response) {
          $log.error('failed to create an education');

          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function getAll() {
      var deferred = $q.defer();

      userEducationEndpoint
        .getAll()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function update(data) {
      var deferred = $q.defer();

      userEducationEndpoint
        .update(data)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }

    function dropById(id) {
      var deferred = $q.defer();

      userEducationEndpoint
        .dropById(id)
        .then(function() {
          deferred.resolve();
        })
        .catch(function(response) {
          deferred.reject(response.data);
        });

      return deferred.promise;
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userAuthenticationEndpoint', userAuthenticationEndpoint);

  /** @ngInject */
  function userAuthenticationEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      login: login,
      logout: logout,
      refreshToken: refreshToken,
      verifyEmail: verifyEmail
    };

    return service;

    function login(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/auth',
        data: data
      });
    }

    function logout() {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/auth'
      });
    }

    function refreshToken() {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/auth/refresh_token'
      });
    }

    function verifyEmail(email, token) {
      return $http({
        'method': 'GET',
        'url': apiBaseUrl + '/email_verification/' + email + '/' + token
      });
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('userAuthentication', userAuthentication);

  /** @ngInject */
  function userAuthentication(
    $log,
    $q,
    $rootScope,
    $timeout,
    userAuthenticationEndpoint,
    authPrinciple,
    vmsLocalStorage,
    BROADCAST_EVENTS_LIST,
    alertMessage) {
    var authenticated = vmsLocalStorage.jwtExists();
    var currentRole;
    var service = {
      login: login,
      logout: logout,
      setAuthentication: setAuthentication,
      refreshToken: refreshToken,
      verifyEmail: verifyEmail,
      isAuthenticated: isAuthenticated,
      switchRole: switchRole,
      getRole: getRole,
      authorize: authorize
    };

    return service;

    function login(credentials, role) {
      var deferred = $q.defer();

      userAuthenticationEndpoint
        .login(credentials)
        .then(function(response) {
          $log.debug('login success');
          $log.debug(response.headers('Authorization'));

          var jsonWebToken = response.headers('Authorization');
          var value = response.data;

          if (angular.isDefined(jsonWebToken)) {
            authenticated = true;

            $log.debug(value);
            $log.debug('avatar_url = ' + value.data.avatar_url);

            // Store JSON Web Token into local storage for attching into each request
            vmsLocalStorage.setJwt(jsonWebToken);

            // Store username into local storage for displaying username on navbar
            vmsLocalStorage.setUsername(value.data.username);

            // Store last name into local storage for display last name on navbar
            vmsLocalStorage.setLastName(value.data.last_name);

            // Store avatar path into local storage for displaying avatar image on navbar
            vmsLocalStorage.setAvatarPath(value.data.avatar_url);

            // Switch into role
            switchRole(role);

            // broadcast an event, there is a registered listener,
            // it will handle the event
            $rootScope.$broadcast(BROADCAST_EVENTS_LIST.AUTHENTICATED_SUCCESS_EVENT);

            deferred.resolve();
          }
        })
        .catch(function(response) {
          var errors;

          logout();

          if (response.status === 401) {
            errors = ['incorrect_username_or_password'];
          } else {
            errors = response.data.errors;
          }

          var alert = alertMessage.convertToDanger(errors);

          deferred.reject(alert);
        });

      return deferred.promise;
    }

    function logout() {
      $log.debug("authenticated was set into false");

      authenticated = false;

      clearAllLocalStorageKeys();
    }

    function setAuthentication(user, jwt, role) {
      authenticated = true;

      vmsLocalStorage.setUsername(user.username);
      vmsLocalStorage.setLastName(user.last_name);
      vmsLocalStorage.setJwt(jwt);
      vmsLocalStorage.setAvatarPath(user.avatar_url);
      switchRole(role);
    }

    function refreshToken() {
      var deferred = $q.defer();

      userAuthenticationEndpoint
        .refreshToken()
        .then(function(response) {
          var jsonWebToken = response.headers('Authorization');

          if (angular.isDefined(jsonWebToken) && jsonWebToken != null) {
            vmsLocalStorage.setJwt(jsonWebToken);

            deferred.resolve(jsonWebToken);
          } else {
            deferred.reject();
          }
        })
        .catch(function(response) {
          $log.error("refreshToken catch()");

          logout();

          deferred.reject();
        });

      return deferred.promise;
    }

    function verifyEmail(email, token) {
      var deferred = $q.defer();

      userAuthenticationEndpoint
        .verifyEmail(email, token)
        .then(function(response) {
          var value = response.data;

          deferred.resolve(value);
        })
        .catch(function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function isAuthenticated() {
      return authenticated;
    }

    function switchRole(role) {
      vmsLocalStorage.setRole(role);

      currentRole = role;
    }

    function getRole() {
      if (!angular.isDefined(currentRole)) {
        currentRole = vmsLocalStorage.getRole();
      }

      return currentRole;
    }

    function authorize() {
      var deferred = $q.defer();

      $timeout(function() {
        if (authPrinciple.identity()) {
          authenticated = true;
          deferred.resolve();
        } else {
          $log.debug("authenticated was set into false");

          authenticated = false;
          deferred.reject();
        }
      }, 500);

      return deferred.promise;
    }

    function clearAllLocalStorageKeys() {
      vmsLocalStorage.removeLastName();
      vmsLocalStorage.removeUsername();
      vmsLocalStorage.removeJwt();
      vmsLocalStorage.removeRole();
      vmsLocalStorage.removeAvatarPath();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('projectHyperlinkEndpoint', projectHyperlinkEndpoint);

  /** @ngInject */
  function projectHyperlinkEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      getByProjectId: getByProjectId,
      create: create,
      dropByProjectIdAndHyperlinkId: dropByProjectIdAndHyperlinkId,
      createOrUpdate: createOrUpdate
    };

    return service;

    function getByProjectId(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks'
      });
    }

    function create(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks',
        data: data
      });
    }

    function dropByProjectIdAndHyperlinkId(projectId, id) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/' + id
      });
    }

    function createOrUpdate(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/create_or_update_bulk',
        data: data
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('projectHyperlink', projectHyperlink);

  /** @ngInject */
  function projectHyperlink($log, $q, projectHyperlinkEndpoint) {
    var service = {
      getByProjectId: getByProjectId,
      create: create,
      dropByProjectIdAndHyperlinkId: dropByProjectIdAndHyperlinkId,
      createOrUpdate: createOrUpdate
    };

    return service;

    function getByProjectId(projectId) {
      var deferred = $q.defer();

      projectHyperlinkEndpoint
        .getByProjectId(projectId)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function create(projectId, data) {
      var deferred = $q.defer();

      projectHyperlinkEndpoint
        .create(projectId, data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.resolve(response);
        });

      return deferred.promise;
    }

    function dropByProjectIdAndHyperlinkId(projectId, hyperlinkId) {
      var deferred = $q.defer();

      projectHyperlinkEndpoint
        .dropByProjectIdAndHyperlinkId(projectId, hyperlinkId)
        .then(function() {
          deferred.resolve();
        })
        .catch(function() {
          deferred.reject();
        });

      return deferred.promise;
    }

    function createOrUpdate(projectId, createdHyperlinks, updatedHyperlinks) {
      var deferred = $q.defer();
      var data = {};

      if (angular.isDefined(createdHyperlinks)
        && createdHyperlinks.length > 0) {
        data['create'] = createdHyperlinks;
      }

      if (angular.isDefined(updatedHyperlinks)
        && updatedHyperlinks.length > 0) {
        data['update'] = updatedHyperlinks;
      }

      projectHyperlinkEndpoint
        .createOrUpdate(projectId, data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('refreshJwtHttpInterceptor', refreshJwtHttpInterceptor);

  /** @ngInject */
  function refreshJwtHttpInterceptor($injector, $q, $log, vmsLocalStorage) {
    $log.debug("### refreshJwtHttpInterceptor ###");

    var service = {

      responseError: function(response) {
        // IMPORTANT!
        // If the service wants use other dependencies, it should use $injector
        // to get the dependencies. Otherwise, the dependency will not be found
        var userAuthentication = $injector.get('userAuthentication');
        var $http = $injector.get('$http');
        var deferred = $q.defer();
        var isAuthenticated = userAuthentication.isAuthenticated();

        $log.debug("### responseError ###");
        $log.debug(response);
        $log.debug('isAuthenticated = ' + isAuthenticated);

        if (response.status === 401 && isAuthenticated) {
          $log.debug("=== 401 ===");

          var successCallback = function(authorizationToken) {
            $log.debug("refresh successCallback()");
            $log.debug(authorizationToken);

            response.config.headers.Authorization = authorizationToken;

            deferred.resolve();
          };
          var failureCallback = function() {
            $log.error("refresh failureCallback()");
            userAuthentication.logout();

            deferred.reject();
          };

          userAuthentication.refreshToken().then(successCallback).catch(failureCallback);

          return deferred.promise.then(function() {
            return $http(response.config);
          });
        }

        $log.debug("### refreshJwtHttpInterceptor reject");

        return $q.reject(response);
      }
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('projectCustomFieldEndpoint', projectCustomFieldEndpoint);

  /** @ngInject */
  function projectCustomFieldEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      getAllByProjectId: getAllByProjectId,
      getMemberDataByProjectId: getMemberDataByProjectId,
      storeOrUpdateByProjectId: storeOrUpdateByProjectId,
      storeOrUpdateMemberDataByProjectId: storeOrUpdateMemberDataByProjectId
    };

    return service;

    function getAllByProjectId(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/custom_fields'
      });
    }

    function getMemberDataByProjectId(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/members/custom_field_data'
      });
    }

    function storeOrUpdateByProjectId(data, projectId) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/custom_fields',
        data: data
      });
    }

    function storeOrUpdateMemberDataByProjectId(data, projectId) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/members/bulk_custom_field_data',
        data: data
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('projectCustomField', projectCustomField);

  /** @ngInject */
  function projectCustomField(
    $log,
    $q,
    projectCustomFieldEndpoint,
    alertMessage
  ) {
    var service = {
      getAllByProjectId: getAllByProjectId,
      getMemberDataByProjectId: getMemberDataByProjectId,
      storeOrUpdateByProjectId: storeOrUpdateByProjectId,
      storeOrUpdateMemberDataByProjectId: storeOrUpdateMemberDataByProjectId
    };

    return service;

    function getAllByProjectId(projectId) {
      var deferred = $q.defer();

      projectCustomFieldEndpoint
        .getAllByProjectId(projectId)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function getMemberDataByProjectId(projectId) {
      var deferred = $q.defer();

      projectCustomFieldEndpoint
        .getMemberDataByProjectId(projectId)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function storeOrUpdateByProjectId(data, projectId) {
      var deferred = $q.defer();

      projectCustomFieldEndpoint
        .storeOrUpdateByProjectId(data, projectId)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }

    function storeOrUpdateMemberDataByProjectId(data, projectId) {
      var deferred = $q.defer();

      projectCustomFieldEndpoint
        .storeOrUpdateMemberDataByProjectId(data, projectId)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var value = response.data;
          var errors = value.errors;
          var alerts;

          if (response.status === 422) {
            alerts = alertMessage.convertToValidationDanger(errors);
          } else {
            alerts = alertMessage.convertToDanger(errors);
          }

          deferred.reject(alerts);
        });

      return deferred.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('apiKeyHttpInterceptor', apiKeyHttpInterceptor);

  /** @ngInject */
  function apiKeyHttpInterceptor(config) {
    var service = {

      request: function(configHeader) {

        configHeader.headers['X-VMS-API-Key'] = config.apiKey;

        return configHeader;
      }
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('jwtHttpInterceptor', jwtHttpInterceptor);

  /** @ngInject */
  function jwtHttpInterceptor($injector, $log) {
    var service = {

      request: function(config) {
        var authPrinciple = $injector.get('authPrinciple');
        var vmsLocalStorage = $injector.get('vmsLocalStorage');

        if (authPrinciple.identity()) {
          $log.debug('token key exists');

          config.headers['Authorization'] = vmsLocalStorage.getJwt();
        } else {
          $log.debug('token key is not found');
        }

        return config;
      }
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(
    $log,
    $stateParams,
    userPassword
  ) {
    var vm = this;
    vm.submit = submit;
    vm.data = {};
    vm.showResetForm = false;

    var email = $stateParams.email;
    var token = $stateParams.token;

    angular.element(document).ready(function() {
      $log.debug('ready');

      verifyPasswordReset();
    });

    function submit() {
      vm.alert = [];

      userPassword
        .resetPassword(email, token, vm.data.password, vm.data.passwordConfirmation)
        .then(function() {
          vm.alert.push({
            type: 'success',
            data: {
              message: 'alert.success.reset_password_successfully'
            }
          });
        })
        .catch(function(alert) {
          vm.alert.push(alert);
        });
    }

    function verifyPasswordReset() {
      $log.debug('verifyPasswordReset()');

      userPassword
        .verifyPasswordReset(email, token)
        .then(function() {
          vm.showResetForm = true;
        })
        .catch(function(alert) {
          vm.alert = [alert];
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserRegisterController', UserRegisterController);

  /** @ngInject */
  function UserRegisterController($log, $state, fieldName, defaultAvatarPath, userProfile, vmsErrorMessage, $scope, cities, vmsLocalStorage) {
    var vm = this;
    vm.cities = cities;

    $log.log('UserRegisterController');

    vm.showAvatar = defaultAvatarPath;

    vm.datePicker = {
      mode: 'year',
      dateOptions: {
        datepickerMode: "'year'",
        minMode: "'year'",
        minDate: "minDate",
        showWeeks: "false"
      },
      status: {
        opened: false
      },
      format: 'yyyy'
    };

    vm.register = function() {
      $log.debug('=== register ===');

      $log.debug(vm.volunteer);

      if (vm.showAvatar != defaultAvatarPath) {
        vm.volunteer.avatar = vm.showAvatar;
      }

      var onSuccess = function(response) {
        $state.go('registerSuccess', {
          last_name: vm.volunteer.last_name,
          email: vm.volunteer.email
        });
      };
      var onFailure = function(alert) {
        $log.debug(alert);
        vm.alerts = [];
        vm.alerts.push(alert);

        $log.debug(vm.alerts);
      };

      // Password confirmation
      if (vm.volunteer.password != vm.passwordConfirm) {
        vm.alert = [];
        vm.alert.push({
          type: 'danger',
          message: '密碼不相符'
        });

        return;
      }
      userProfile
        .create(vm.volunteer, 'volunteer')
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.selectAvatar = function(event, fileReader, file, fileList, fileObjects, object) {
      var base64Image = "data:" + object.filetype + ';base64,' + object.base64
      vm.showAvatar = base64Image;
    };

    vm.openDatePicker = function($event) {
      $log.debug("click openDatePicker");
      $event.preventDefault();
      $event.stopPropagation();
      vm.datePicker.status.opened = true;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserLoginController', UserLoginController);

  /** @ngInject */
  function UserLoginController($log, userAuthentication, $rootScope, $state) {
    var vm = this;
    vm.alert = [];

    vm.login = function() {

      $log.debug('=== vm.role ===');
      $log.debug(vm.role);

      var onSuccess = function() {
        $log.debug('login success');

        // if the next state is login, it will go to profile state
        if ($rootScope.toState.name == 'login') {
          $state.go('profile');
        } else {

          // go to next with parameters
          if (angular.isDefined($rootScope.toStateParams)) {
            $state.go($rootScope.toState.name, $rootScope.toStateParams);
          } else {
            $state.go($rootScope.toState.name);
          }
        }
      };
      var onFailure = function(alert) {
        $log.debug('login error');
        $log.debug(alert);

        vm.alert = [];
        vm.alert.push(alert);
      };

      userAuthentication
        .login(vm.credentials, vm.role)
        .then(onSuccess)
        .catch(onFailure);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(
    $log,
    userPassword
  ) {
    var vm = this;
    vm.submit = submit;
    vm.data = {};

    function submit() {
      $log.debug("vm.data");
      $log.debug(vm.data);

      vm.alert = [];

      userPassword
        .forgotPassword(vm.data)
        .then(function() {
          vm.alert.push({
            type: 'success',
            data: {
              message: 'alert.success.sent_password_reset'
            }
          });
        })
        .catch(function(alert) {
          vm.alert.push(alert);
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserExperienceController', UserExperienceController);

  function UserExperienceController(
    $log,
    userExperience,
    $filter
  ) {
    var vm = this;
    var beginYear = 1970;
    vm.years = new Array();
    vm.isShowAddExperience = false;

    angular.element(document).ready(getExperiences);
    angular.element(document).ready(setYear);

    function getExperiences() {
      var onSuccess = function(value) {
        $log.debug(value);

        vm.experiences = value.experiences;

        if (angular.isDefined(value)) {
          $log.debug('vm.experiences.length');
          $log.debug(vm.experiences.length);

          if (vm.experiences.length == 0) {
            vm.isShowAddExperience = true;
          }
        } else {
          $log.debug('experience value is not defined');

          vm.isShowAddExperience = true;
        }

      };

      userExperience
        .getAll()
        .then(onSuccess);
    }

    function setYear() {
      var nowDate = new Date();

      for (var year = beginYear; year <= nowDate.getFullYear(); year++) {
        vm.years.push({
          value: year,
          text: year + ' 年'
        });
      }
    }

    function getEditableObject(id) {
      var objName = 'experience' + id;
      var editableObj = vm[objName];

      return editableObj;
    }

    function transformToDate(year) {
      return new Date(year, 1);
    }

    vm.addExperience = function() {

      var onSuccess = function(data) {
        getExperiences();
        vm.isShowAddExperience = false;
      };
      var onFailure = function(data) {};

      $log.debug('addExperiences()');
      $log.debug(vm.sExperience);

      userExperience
        .create(vm.sExperience)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.updateExperience = function(id) {
      var getByIdFilter = $filter('getById');
      var experience = getByIdFilter(vm.experiences, id);

      $log.debug(experience);

      var onSuccess = function() {
        getEditableObject(id).$hide();
      };
      var onFailure = function() {
        /**
         * TODO: show error msg
         */
      };

      userExperience
        .update(experience)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.deleteExperience = function(id) {
      var onSuccess = function() {
        getEditableObject(id).$hide();
        getExperiences();
      };
      var onFailure = function() {
        /**
         * TODO: show error msg
         */
      };

      userExperience
        .dropById(id)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.editableFormShow = function(id) {

      getEditableObject(id).$show();
    };

    vm.editableIsVisible = function(id) {

      $log.debug('vm.editableIsVisible()');

      var editableObj = getEditableObject(id);

      if (editableObj == null) {
        return false;
      }

      var visible = editableObj.$visible;

      return visible;
    };

    vm.editableFormCancel = function(id) {
      getEditableObject(id).$cancel();
    };

    vm.setAddExperienceVisible = function() {
      vm.isShowAddExperience = true;
    };

    vm.setAddExperienceInvisible = function() {
      vm.isShowAddExperience = false;
    };

    vm.onShowEditableForm = function(id) {
      var formElement = angular.element(document).find('form[name="vm.experience' + id + '"]');
      formElement.addClass('editable-form-section');
    };

    vm.onHideEditableForm = function(id) {
      var formElement = angular.element(document).find('form[name="vm.experience' + id + '"]');
      formElement.removeClass('editable-form-section');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('UserEducationController', UserEducationController);

  function UserEducationController(
    $log,
    userEducation,
    EDUCATION_DEGREES,
    $filter) {
    var vm = this;
    var beginYear = 1970;
    vm.years = new Array();
    vm.isShowAddEducation = false;

    angular.element(document).ready(getEducations);
    angular.element(document).ready(setYear);
    angular.element(document).ready(setDegree);

    function getEducations() {
      var onSuccess = function(value) {
        $log.debug(value);

        vm.educations = value.educations;

        if (angular.isDefined(value)) {
          $log.debug('vm.educations.length');
          $log.debug(vm.educations.length);

          if (vm.educations.length == 0) {
            vm.isShowAddEducation = true;
          }
        } else {
          $log.debug('education value is not defined');

          vm.isShowAddEducation = true;
        }

      };

      userEducation
        .getAll()
        .then(onSuccess);
    }

    function setYear() {
      var nowDate = new Date();

      for (var year = beginYear; year <= nowDate.getFullYear(); year++) {
        vm.years.push({
          value: year,
          text: year + ' 年'
        });
      }
    }

    function setDegree() {
      vm.degrees = EDUCATION_DEGREES;
    }

    function getEditableObject(id) {
      var objName = 'education' + id;
      var editableObj = vm[objName];

      return editableObj;
    }

    function transformToDate(year) {
      return new Date(year, 1);
    }

    vm.addEducation = function() {

      var onSuccess = function(data) {
        getEducations();
        vm.isShowAddEducation = false;
      };
      var onFailure = function(data) {};

      $log.debug('addEducations()');
      $log.debug(vm.sEducation);

      userEducation
        .create(vm.sEducation)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.updateEducation = function(id) {
      var getByIdFilter = $filter('getById');
      var education = getByIdFilter(vm.educations, id);

      $log.debug(education);

      var onSuccess = function() {
        getEditableObject(id).$hide();
      };
      var onFailure = function() {
        /**
         * TODO: show error msg
         */
      };

      userEducation
        .update(education)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.deleteEducation = function(id) {
      var onSuccess = function() {
        getEditableObject(id).$hide();
        getEducations();
      };
      var onFailure = function() {
        /**
         * TODO: show error msg
         */
      };

      userEducation
        .dropById(id)
        .then(onSuccess)
        .catch(onFailure);
    };

    vm.editableFormShow = function(id) {

      getEditableObject(id).$show();
    };

    vm.editableIsVisible = function(id) {

      $log.debug('vm.editableIsVisible()');

      var editableObj = getEditableObject(id);

      if (editableObj == null) {
        return false;
      }

      var visible = editableObj.$visible;

      return visible;
    };

    vm.editableFormCancel = function(id) {
      getEditableObject(id).$cancel();
    };

    vm.setAddEducationVisible = function() {
      vm.isShowAddEducation = true;
    };

    vm.setAddEducationInvisible = function() {
      vm.isShowAddEducation = false;
    };

    vm.onShowEditableForm = function(id) {
      var formElement = angular.element(document).find('form[name="vm.education' + id + '"]');
      formElement.addClass('editable-form-section');
    };

    vm.onHideEditableForm = function(id) {
      var formElement = angular.element(document).find('form[name="vm.education' + id + '"]');
      formElement.removeClass('editable-form-section');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ChangePasswordController', ChangePasswordController);

  /** @ngInject */
  function ChangePasswordController(
    $log,
    userPassword
  ) {
    var vm = this;
    vm.submit = submit;
    vm.data = {};

    function submit() {
      $log.debug("vm.data");
      $log.debug(vm.data);

      vm.alert = [];

      userPassword
        .update(vm.data.password, vm.data.newPassword)
        .then(function() {
          vm.alert.push({
            type: 'success',
            data: {
              message: 'alert.success.changed_password'
            }
          });
        })
        .catch(function(alert) {
          vm.alert.push(alert);
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('ProjectPanelController', ProjectPanelController);

  /** @ngInject */
  function ProjectPanelController($log, projectData) {
    var vm = this;
    vm.project = projectData.data;
    vm.meta = projectData.meta;

    $log.debug(vm.project);

    vm.isGuest = function() {
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'guest';
      }

      return false;
    };

    vm.isCreator = function() {
      $log.debug('isCreator()');
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'creator';
      }

      return false;
    };

    vm.isMember = function() {
      if (angular.isDefined(vm.project)) {
        return vm.meta.role.name == 'member';
      }

      return false;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('EditProjectController', EditProjectController);

  /** @ngInject */
  function EditProjectController(
    $log,
    project,
    projectData,
    projectHyperlink,
    lodash,
    PERMISSION_OPTIONS,
    FROALA_OPTIONS) {
    var vm = this;
    vm.project = projectData.data;
    vm.hyperlinks;
    vm.permissionOptions = PERMISSION_OPTIONS;
    vm.froalaOptions = FROALA_OPTIONS;

    vm.update = function() {
      var onSuccess = function(response) {
        $log.debug('project update successfully');
        $log.debug(response.data);
      };
      var onFailure = function(response) {
        $log.error('project update failure');
        $log.error(response);
      };

      project
        .update(vm.project)
        .then(onSuccess)
        .catch(onFailure);

      createOrUpdateHyperlinks();
    };

    function createOrUpdateHyperlinks() {
      var newHyperlinks = lodash.filter(vm.hyperlinks, function(item) {
        return !angular.isDefined(item.id);
      });

      var updateHyperlinks = lodash.filter(vm.hyperlinks, function(item) {
        return angular.isDefined(item.id);
      });

      $log.debug("newHyperlinks");
      $log.debug(newHyperlinks);

      $log.debug("updateHyperlinks");
      $log.debug(updateHyperlinks);

      projectHyperlink.createOrUpdate(
        vm.project.id,
        newHyperlinks,
        updateHyperlinks);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .controller('CreateProjectController', CreateProjectController);

  /** @ngInject */
  function CreateProjectController(
    $log,
    $state,
    $translate,
    project,
    projectHyperlink,
    PERMISSION_OPTIONS,
    FROALA_OPTIONS
  ) {
    var vm = this;
    vm.permissionOptions = PERMISSION_OPTIONS;
    vm.froalaOptions = FROALA_OPTIONS;
    vm.hyperlinks = [
      {
        name: '',
        link: ''
      }
    ];

    vm.create = function() {
      vm.alert = [];

      project
        .create(vm.project)
        .then(function(value) {
          $log.debug(value);

          var projectId = value.id;

          storeHyperlinks(projectId);
        })
        .catch(function(alert) {
          vm.alert.push(alert);
        });
    };

    function storeHyperlinks(projectId) {
      projectHyperlink
        .create(projectId, vm.hyperlinks)
        .then(function() {
          $log.debug("storeHyperlinks() success");
          $log.debug("projectId = " + projectId);

          $state.go('projectDetail', {
            id: projectId
          });
        })
        .catch(function() {
          $log.debug("storeHyperlinks() failure");
        })
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('yesNo', yesNo);

  /** @ngInject */
  function yesNo() {
    var filter = function(input) {
      return input ? '是' : '否';
    };

    return filter;
  }
})();

(function() {
  'use strict';
  angular
    .module('vmsFrontend')
    .factory('volunteerProfileEndPoint', volunteerProfileEndPoint);

  /** @ngInject */
  function volunteerProfileEndPoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      get: get,
      getAttendingProjects: getAttendingProjects
    };

    return service;

    function get() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me'
      });
    }

    function getAttendingProjects(id) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/' + id + '/attending_projects'
      });
    }
  }

})();

(function() {
  'use strict';
  angular.module('vmsFrontend').factory('volunteer', volunteer);

  /** @ngInject */
  function volunteer($q, $log, vmsClient, volunteerProfileEndPoint, defaultAvatarPath, cities) {
    var service = {
      getProfile: getProfile,
      updateProfile: updateProfile,
      getExperiences: getExperiences,
      addExperience: addExperience,
      updateExperience: updateExperience,
      deleteExperience: deleteExperience,
      getEducations: getEducations,
      addEducation: addEducation,
      updateEducation: updateEducation,
      deleteEducation: deleteEducation,
      getSkillCandidatedKeywords: getSkillCandidatedKeywords,
      getEquipmentCandidatedKeywords: getEquipmentCandidatedKeywords,
      getSkills: getSkills,
      updateSkills: updateSkills,
      getEquipment: getEquipment,
      updateEquipment: updateEquipment,
      getAttendingProjects: getAttendingProjects
    };
    return service;

    function getProfile() {
      var deferred = $q.defer();

      var handleRequestSucess = function(response) {
        var profile;

        $log.debug("success");
        $log.debug(response.data);

        profile = response.data.data;

        cities.forEach(function(city) {
          if (city.id == profile.city.id) {
            $log.debug(city.name_zh_tw);
            profile.city.name_zh_tw = city.name_zh_tw;
          }
        });

        // TODO: The avatar string need to be refactored
        if (profile.avatar_url == "http://vms-openisdm.s3-website-ap-northeast-1.amazonaws.com/upload/avatars/") {
          profile.avatar_url = defaultAvatarPath;
        }

        deferred.resolve(profile);
      };
      var handleRequestError = function(response) {
        $log.debug('error');
        $log.debug(response);

        deferred.reject(response);
      };

      vmsClient.getProfile()
        .then(handleRequestSucess)
        .catch(handleRequestError);

      return deferred.promise;
    }

    function updateProfile(profile) {
      var deferred = $q.defer();

      // remove the avatar_url property
      delete profile.avatar_url;
      delete profile.email;

      var onSuccess = function(response) {
        $log.debug('update profile successfully');

        deferred.resolve(response.data);
      };

      var onFailure = function(response) {
        $log.debug('update profile failed');

        deferred.reject(response.data);
      };

      vmsClient.updateProfile(profile)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getExperiences() {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('get experiences successfully');

        deferred.resolve(response.data.experiences);
      };
      var onFailure = function(response) {
        $log.debug('get experiences failed');

        deferred.reject(response.data);
      };

      vmsClient.getExperiences()
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function addExperience(data) {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('add experience successfully');

        deferred.resolve(response.data);
      };
      var onFailure = function(response) {
        $log.debug('add experience failed');

        deferred.reject(response.data);
      };

      vmsClient.addExperience(data)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function updateExperience(data) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('update experience successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('update experience failed');

        deferred.reject(response.data);
      };

      vmsClient.updateExperience(data)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function deleteExperience(id) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('delete experience successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('delete experience failed');

        deferred.reject(response.data);
      };

      vmsClient.deleteExperience(id)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getEducations() {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('get educations successfully');

        deferred.resolve(response.data.educations);
      };
      var onFailure = function(response) {
        $log.debug('get educations failed');

        deferred.reject(response.data);
      };

      vmsClient.getEducations()
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function addEducation(data) {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('add education successfully');

        deferred.resolve(response.data);
      };
      var onFailure = function(response) {
        $log.debug('add education failed');

        deferred.reject(response.data);
      };

      vmsClient.addEducation(data)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function updateEducation(data) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('update education successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('update education failed');

        deferred.reject(response.data);
      };

      vmsClient.updateEducation(data)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function deleteEducation(id) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('delete education successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('delete education failed');

        deferred.reject(response.data);
      };

      vmsClient.deleteEducation(id)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getSkillCandidatedKeywords(keyword) {
      var deferred = $q.defer();

      $log.debug('volunteer.getSkillCandidatedKeywords()');

      if (angular.isDefined(keyword) && keyword != '') {

        var onSuccess = function(response) {
          $log.debug('get skill candidated keywords successfully');

          deferred.resolve(response.data.result);
        };
        var onFailure = function(response) {
          $log.debug('get skill candidated keywords failed');

          deferred.reject(response.data);
        };

        vmsClient.getSkillCandidatedKeywords(keyword)
          .then(onSuccess)
          .catch(onFailure);
      } else {
        deferred.reject();
      }

      return deferred.promise;
    }

    function getEquipmentCandidatedKeywords(keyword) {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('get equipment candidated keywords successfully');

        deferred.resolve(response.data.result);
      };
      var onFailure = function(response) {
        $log.debug('get equipment candidated keywords failed');

        deferred.reject(response.data);
      };

      vmsClient.getEquipmentCandidatedKeywords(keyword)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getSkills() {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('get skills successfully');

        deferred.resolve(response.data.skills);
      };
      var onFailure = function(response) {
        $log.debug('get skills failed');

        deferred.reject(response.data);
      };

      vmsClient.getSkills()
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function updateSkills(skills, existingIndexes) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('update skills successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('update skills failed');

        deferred.reject(response.data);
      };

      var sSkills = [];
      angular.forEach(skills, function(value) {
        sSkills.push(value.name);
      });

      var updateSkills = {
        'skills': sSkills,
        'existing_skill_indexes': existingIndexes
      }

      vmsClient.updateSkills(updateSkills)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getEquipment() {
      var deferred = $q.defer();

      var onSuccess = function(response) {
        $log.debug('get equipment successfully');

        deferred.resolve(response.data.equipment);
      };
      var onFailure = function(response) {
        $log.debug('get equipment failed');

        deferred.reject(response.data);
      };

      vmsClient.getEquipment()
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function updateEquipment(equipment, existingIndexes) {
      var deferred = $q.defer();

      var onSuccess = function() {
        $log.debug('update equipment successfully');

        deferred.resolve();
      };
      var onFailure = function(response) {
        $log.debug('update equipment failed');

        deferred.reject(response.data);
      };

      var sEquipment = [];
      angular.forEach(equipment, function(value) {
        sEquipment.push(value.name);
      });

      var updateEquipment = {
        'equipment': sEquipment,
        'existing_equipment_indexes': existingIndexes
      }

      vmsClient.updateEquipment(updateEquipment)
        .then(onSuccess)
        .catch(onFailure);

      return deferred.promise;
    }

    function getAttendingProjects(userId) {
      var deferred = $q.defer();

      volunteerProfileEndPoint
        .getAttendingProjects(userId)
        .then(function(response) {
          $log.debug(response);

          deferred.resolve(response.data);
        })
        .catch(function(response) {
          $log.error(response);

          deferred.reject(response);
        });

      return deferred.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('vmsMessage', vmsMessage);

  /** @ngInject */
  function vmsMessage() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/vmsMessageDirective/vmsMessageDirective.html',
      scope: {
        data: '='
      },
      controller: VmsMessageController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }

  /** @ngInject */
  function VmsMessageController($log) {
    var vm = this;

    vm.isArray = isArray;

    $log.debug('VmsMessageController');

    if (vm.data instanceof Array) {
      vm.data.forEach(function(element, index, array) {
        $log.debug('forEach');
        $log.debug(element);

        if (vm.data[index].type === 'info') {
          array[index]['timeout'] = 6500;
        } else {
          array[index]['timeout'] = 'none';
        }
      });
    }

    function isArray(value) {
      return angular.isArray(value);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('vmsLocalStorage', vmsLocalStorage);

  /** @ngInject */
  function vmsLocalStorage($log, localStorageService, LOCAL_STORAGE_CONFIG) {
    var service = {
      setJwt: setJwt,
      getJwt: getJwt,
      removeJwt: removeJwt,
      jwtExists: jwtExists,
      setLastName: setLastName,
      getLastName: getLastName,
      removeLastName: removeLastName,
      setUsername: setUsername,
      getUsername: getUsername,
      removeUsername: removeUsername,
      getRole: getRole,
      setRole: setRole,
      removeRole: removeRole,
      getAvatarPath: getAvatarPath,
      setAvatarPath: setAvatarPath,
      removeAvatarPath: removeAvatarPath,
    };

    return service;

    function setJwt(token) {
      return localStorageService.set(LOCAL_STORAGE_CONFIG.keys.jwt, token);
    }

    function getJwt() {
      return localStorageService.get(LOCAL_STORAGE_CONFIG.keys.jwt);
    }

    function removeJwt() {
      return localStorageService.remove(LOCAL_STORAGE_CONFIG.keys.jwt);
    }

    function jwtExists() {
      return keyExists(LOCAL_STORAGE_CONFIG.keys.jwt);
    }

    function setLastName(lastName) {
      return localStorageService.set(LOCAL_STORAGE_CONFIG.keys.lastName, lastName);
    }

    function getLastName() {
      return localStorageService.get(LOCAL_STORAGE_CONFIG.keys.lastName);
    }

    function removeLastName() {
      return localStorageService.remove(LOCAL_STORAGE_CONFIG.keys.lastName);
    }

    function setUsername(userName) {
      return localStorageService.set(LOCAL_STORAGE_CONFIG.keys.userName, userName);
    }

    function getUsername() {
      return localStorageService.get(LOCAL_STORAGE_CONFIG.keys.userName);
    }

    function removeUsername() {
      return localStorageService.remove(LOCAL_STORAGE_CONFIG.keys.userName);
    }

    function setRole(token) {
      return localStorageService.set(LOCAL_STORAGE_CONFIG.keys.role, token);
    }

    function getRole() {
      return localStorageService.get(LOCAL_STORAGE_CONFIG.keys.role);
    }

    function removeRole() {
      return localStorageService.remove(LOCAL_STORAGE_CONFIG.keys.role);
    }

    function keyExists(keyName) {
      var lsKeys = localStorageService.keys();

      if (lsKeys.indexOf(keyName) != -1) {
        return true;
      }

      return false;
    }

    function getAvatarPath() {
      return localStorageService.get(LOCAL_STORAGE_CONFIG.keys.avatarPath);
    }

    function setAvatarPath(path) {
      return localStorageService.set(LOCAL_STORAGE_CONFIG.keys.avatarPath, path);
    }

    function removeAvatarPath() {
      return localStorageService.remove(LOCAL_STORAGE_CONFIG.keys.avatarPath);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('vmsErrorMessage', vmsErrorMessage);

  /** @ngInject */
  function vmsErrorMessage($log) {
    var service = {
      getErrorMsg: getErrorMsg,
      fieldMsg: fieldMsg
    };

    return service;

    function getErrorMsg(errors) {
      $log.log('getErrorMsg');
      $log.log(errors);

      var errorMsgs = [];
      errors.forEach(function(error) {
        if (error.code == "used_field") {
          errorMsgs.push("被使用的 " + fieldMsg(error));
        } else if (error.code == "missing_field") {
          errorMsgs.push("未輸入的 " + fieldMsg(error));
        } else if (error.code == "not_enough_password_strength") {
          errorMsgs.push("密碼強度不足");
        }
      });

      return errorMsgs.join(";");
    }

    function fieldMsg(error) {
      var fields = error.fields;

      return fields.join(", ");
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('vmsClient', vmsClient);

  /** @ngInject */
  function vmsClient(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      register: register,
      login: login,
      logout: logout,
      emailVerification: emailVerification,
      getProfile: getProfile,
      updateProfile: updateProfile,
      refreshToken: refreshToken,
      deleteAccount: deleteAccount,
      getExperiences: getExperiences,
      addExperience: addExperience,
      updateExperience: updateExperience,
      deleteExperience: deleteExperience,
      getEducations: getEducations,
      addEducation: addEducation,
      updateEducation: updateEducation,
      deleteEducation: deleteEducation,
      getSkillCandidatedKeywords: getSkillCandidatedKeywords,
      getEquipmentCandidatedKeywords: getEquipmentCandidatedKeywords,
      getSkills: getSkills,
      updateSkills: updateSkills,
      getEquipment: getEquipment,
      updateEquipment: updateEquipment,
      addProject: addProject,
      getManagedProjects: getManagedProjects,
      getAttendingProject: getAttendingProject,
      getProject: getProject,
      updateProject: updateProject,
      getProjectCustomFields: getProjectCustomFields,
      updateProjectCustomField: updateProjectCustomField,
      attendProject: attendProject,
      fillProjectCustomFieldData: fillProjectCustomFieldData,
      getProjectCustomFieldData: getProjectCustomFieldData,
      getProjectMembers: getProjectMembers,
      getAllMembersCustomFieldData: getAllMembersCustomFieldData,
      getAllProjects: getAllProjects
    };

    return service;

    function register(volunteer) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/register',
        data: volunteer
      });
    }

    function login(credentials) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/auth',
        data: credentials
      });
    }

    function logout() {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/auth'
      });
    }

    function emailVerification(email, verification_token) {
      return $http({
        'method': 'GET',
        'url': apiBaseUrl + '/email_verification/' + email + '/' + verification_token
      });
    }

    function getProfile() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me'
      });
    }

    function updateProfile(profile) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me',
        data: profile
      });
    }

    function refreshToken() {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/auth/refresh_token'
      });
    }

    function deleteAccount(credentials) {
      /**
       * @TODO: change the POST action into DELETE (?)
       */
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/delete',
        data: credentials
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getExperiences() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/experiences',
      });
    }

    /**
     * @TODO: Unit testing
     */
    function addExperience(experience) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/experiences',
        data: experience
      });
    }

    /**
     * @TODO: Unit testing
     */
    function updateExperience(experience) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me/experiences',
        data: experience
      });
    }

    /**
     * @TODO: Unit testing
     */
    function deleteExperience(experienceId) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/users/me/experiences/' + experienceId
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getEducations() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/educations',
      });
    }

    /**
     * @TODO: Unit testing
     */
    function addEducation(education) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/educations',
        data: education
      });
    }

    /**
     * @TODO: Unit testing
     */
    function updateEducation(education) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/users/me/educations',
        data: education
      });
    }

    /**
     * @TODO: Unit testing
     */
    function deleteEducation(educationId) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/users/me/educations/' + educationId
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getSkillCandidatedKeywords(keyword) {
      $log.debug('vmsClient.getSkillCandidatedKeywords()');
      $log.debug(keyword);

      return $http({
        method: 'GET',
        url: apiBaseUrl + '/skill_candidates/' + keyword
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getEquipmentCandidatedKeywords(keyword) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/equipment_candidates/' + keyword,
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getSkills() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/skills',
      });
    }

    /**
     * @TODO: Unit testing
     */
    function updateSkills(skills) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/skills',
        data: skills
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getEquipment() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/users/me/equipment',
      });
    }

    /**
     * @TODO: Unit testing
     */
    function updateEquipment(equipment) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/users/me/equipment',
        data: equipment
      });
    }

    /**
     * @TODO: Unit testing
     */
    function addProject(project) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects',
        data: project
      });
    }

    /**
     * @TODO: Unit testing
     */
    function getManagedProjects() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/managed_projects',
      });
    }

    function getAttendingProject() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/attending_projects',
      });
    }

    function getProject(id) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + id,
      });
    }

    function updateProject(value) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/projects/' + value.id,
        data: value
      });
    }

    function getProjectCustomFields(id) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + id + '/custom_fields',
      });
    }

    function updateProjectCustomField(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/custom_fields',
        data: data
      });
    }

    function attendProject(projectId) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/attend',
        data: []
      });
    }

    function fillProjectCustomFieldData(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/members/bulk_custom_field_data',
        data: data
      });
    }

    function getProjectCustomFieldData(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/members/custom_field_data'
      });
    }

    function getProjectMembers(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/members'
      });
    }

    function getAllMembersCustomFieldData(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/members/all_custom_field_data'
      });
    }

    function getAllProjects() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects'
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('requiredLabel', requiredLabel);

  /** @ngInject */
  function requiredLabel() {
    var directive = {
      restrict: 'A',
      compile: function(element) {
        element.append("<span class='required-star'>*</span>");
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('projectHyperlinks', projectHyperlinks);

  /** @ngInject */
  function projectHyperlinks() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/projectHyperlinksDirective/projectHyperlinksDirective.html',
      scope: {
        projectId: '='
      },
      controller: ProjectHyperlinksDirectiveController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }

  /** @ngInject */
  function ProjectHyperlinksDirectiveController($log, projectHyperlink) {
    var vm = this;
    vm.data = [];

    $log.debug("ProjectHyperlinksDirectiveController");

    $log.debug("vm.projectId = " + vm.projectId);

    if (angular.isDefined(vm.projectId)) {
      $log.debug("vm.projectId is defined.");
      $log.debug("vm.projectId = " + vm.projectId);

      var onSuccess = function(value) {
        vm.data = value.data;
      };

      projectHyperlink
        .getByProjectId(vm.projectId)
        .then(onSuccess);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('projectEndpoint', projectEndpoint);

  /** @ngInject */
  function projectEndpoint(
    $log,
    $http,
    config
  ) {
    var apiBaseUrl = config.apiBaseUrl;
    var service = {
      getById: getById,
      getAll: getAll,
      getManagedProjectList: getManagedProjectList,
      create: create,
      update: update,
      getHyperlinks: getHyperlinks,
      storeHyperlinks: storeHyperlinks,
      deleteHyperlinks: deleteHyperlinks,
      createOrUpdateHyperlinks: createOrUpdateHyperlinks
    };

    return service;

    function getById(id) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + id,
      });
    }

    function getAll() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects'
      });
    }

    function getManagedProjectList() {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/managed_projects'
      });
    }

    function create(data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects',
        data: data
      });
    }

    function update(id, data) {
      return $http({
        method: 'PUT',
        url: apiBaseUrl + '/projects/' + id,
        data: data
      });
    }

    function getHyperlinks(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks'
      });
    }

    function storeHyperlinks(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks',
        data: data
      });
    }

    function deleteHyperlinks(projectId, hyperlinkId) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/' + hyperlinkId
      });
    }

    function createOrUpdateHyperlinks(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/create_or_update_bulk',
        data: data
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('project', project);

  /** @ngInject */
  function project(
    $log,
    $q,
    projectEndpoint,
    alertMessage) {
    var service = {
      getById: getById,
      getAll: getAll,
      getManagedProjectList: getManagedProjectList,
      create: create,
      update: update,
      getHyperlinks: getHyperlinks,
      storeHyperlinks: storeHyperlinks,
      deleteHyperlinks: deleteHyperlinks,
      createOrUpdateHyperlinks: createOrUpdateHyperlinks
    };

    return service;

    function getById(id) {
      var deferred = $q.defer();

      projectEndpoint
        .getById(id)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var alert = alertMessage.convertToDanger(response.data);

          deferred.reject(alert);
        })

      return deferred.promise;
    }

    function getAll() {
      var deferred = $q.defer();

      projectEndpoint
        .getAll()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function getManagedProjectList() {
      var deferred = $q.defer();

      projectEndpoint
        .getManagedProjectList()
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var alert = alertMessage.convertToDanger(response.data);

          deferred.reject(alert);
        });

      return deferred.promise;
    }

    function create(data) {
      var deferred = $q.defer();

      projectEndpoint
        .create(data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var alert = alertMessage.convertToDanger(response.data);

          deferred.reject(alert);
        });

      return deferred.promise;
    }

    function update(data) {
      var deferred = $q.defer();

      projectEndpoint
        .update(data.id, data)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(response) {
          var alert = alertMessage.convertToDanger(response.data);

          deferred.reject(alert);
        });

      return deferred.promise;
    }

    function getHyperlinks(projectId) {
      return $http({
        method: 'GET',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks'
      });
    }

    function storeHyperlinks(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks',
        data: data
      });
    }

    function deleteHyperlinks(projectId, hyperlinkId) {
      return $http({
        method: 'DELETE',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/' + hyperlinkId
      });
    }

    function createOrUpdateHyperlinks(projectId, data) {
      return $http({
        method: 'POST',
        url: apiBaseUrl + '/projects/' + projectId + '/hyperlinks/create_or_update_bulk',
        data: data
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('permissionText', permissionText);

  /** @ngInject */
  function permissionText($log, PERMISSION_OPTIONS) {
    $log.debug('permissionText');

    var filter = function(input) {
      var text = null;

      $log.debug(input);

      angular.forEach(PERMISSION_OPTIONS, function(item) {
        if (item.value == input) {
          text = item.name;
        }
      });

      $log.debug(text);

      return text;
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('vmsNavbar', vmsNavbar);

  /** @ngInject */
  function vmsNavbar() {
    var avatarPath;
    var lastName;
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(
      $log,
      userAuthentication,
      vmsLocalStorage,
      $state,
      toastr
    ) {
      var vm = this;
      vm.userAuthentication = userAuthentication;
      vm.logout = logout;
      vm.getRole = getRole;
      vm.isManagerRole = isManagerRole;
      vm.isVolunteerRole = isVolunteerRole;
      vm.switchToVolunteer = switchToVolunteer;
      vm.switchToManager = switchToManager;
      vm.getAvatarPath = getAvatarPath;
      vm.getLastName = getLastName;

      function logout() {
        userAuthentication.logout();
        avatarPath = undefined;
        lastName = undefined;
        $state.go('login');
      }

      function getRole() {
        return userAuthentication.getRole();
      }

      function isManagerRole() {
        return userAuthentication.getRole() == 'manager';
      }

      function isVolunteerRole() {
        return userAuthentication.getRole() == 'volunteer';
      }

      function switchToVolunteer() {
        userAuthentication.switchRole('volunteer');
        toastr.clear();
        toastr.success('現在身份為志工', {
          closeButton: true
        });
        $state.go('showAllProjects');
      }

      function switchToManager() {
        userAuthentication.switchRole('manager');
        toastr.clear();
        toastr.success('現在身份為專案管理員', {
          closeButton: true
        });
        $state.go('managedProjectList');
      }

      function getAvatarPath() {
        if (!angular.isDefined(avatarPath) || avatarPath == null) {
          avatarPath = vmsLocalStorage.getAvatarPath();
        }

        return avatarPath;
      }

      function getLastName() {
        if (!angular.isDefined(lastName) || lastName == null) {
          lastName = vmsLocalStorage.getLastName();
        }

        return lastName;
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('htmlize', htmlize);

  /** @ngInject */
  function htmlize($sce) {
    var filter = function(input) {
      return $sce.trustAsHtml(input);
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('getIndexById', getIndexById);

  function getIndexById() {

    return function(input, id) {

      for (var i = 0; i < input.length; i++) {
        if (input[i].id == id) {
          return i;
        }
      }

      return null;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('getById', getById);

  function getById() {

    return function(input, id) {

      for (var i = 0; i < input.length; i++) {
        if (input[i].id == id) {
          return input[i];
        }
      }

      return null;
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('vmsFrontend')
        .directive('formatYear', formatYear);

    /** @ngInject */
    function formatYear($filter, $log) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function(inputValue) {

                    var transformedInput = $filter('date')(inputValue, 'yyyy');

                    $log.debug('=== formatYear directive ===');
                    $log.debug(transformedInput);

                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('formatDateTime', formatDateTime);

  /** @ngInject */
  function formatDateTime($filter, $log) {
    var filter = function(dateString) {
      var dateValue = new Date(dateString);
      var transformedInput = $filter('date')(dateValue, 'yyyy/MM/dd hh:mm', 'UTC');

      $log.debug('=== formatDateTime directive ===');
      $log.debug(transformedInput);

      return transformedInput;
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('editableProjectHyperlinks', editableProjectHyperlinks);

  /** @ngInject */
  function editableProjectHyperlinks() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/editableProjectHyperlinksDirective/editableProjectHyperlinksDirective.html',
      scope: {
        projectId: '=',
        data: '='
      },
      controller: EditableProjectHyperlinksDirectiveController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }

  /** @ngInject */
  function EditableProjectHyperlinksDirectiveController($log, projectHyperlink) {
    var vm = this;
    vm.data = [];

    if (vm.data.length == 0) {
      vm.data.push({
        name: "",
        link: ""
      });
    }

    $log.debug("EditableProjectHyperlinksDirectiveController");

    $log.debug("vm.projectId = " + vm.projectId);

    if (angular.isDefined(vm.projectId)) {
      $log.debug("vm.projectId is defined.");
      $log.debug("vm.projectId = " + vm.projectId);

      var onSuccess = function(value) {
        vm.data = value.data;
      };

      projectHyperlink
        .getByProjectId(vm.projectId)
        .then(onSuccess);
    }

    vm.remove = function(index) {
      $log.debug("remove a project hyperlink");
      $log.debug(index);

      var onSuccess = function() {
        vm.data.splice(index, 1);

        $log.debug(vm.data);
      };

      var onFailure = function(response) {
        $log.error(response);
      };

      if (angular.isDefined(vm.data[index].id)) {
        projectHyperlink
          .dropByProjectIdAndHyperlinkId(vm.projectId, vm.data[index].id)
          .then(onSuccess)
          .catch(onFailure);
      } else {
        vm.data.splice(index, 1);
      }
    }

    vm.append = function() {
      vm.data.push({
        name: "",
        link: ""
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('educationDegree', educationDegree);

  /** @ngInject */
  function educationDegree(EDUCATION_DEGREES, $log) {
    var filter = function(input) {
      var degreeText;

      angular.forEach(EDUCATION_DEGREES, function(degree) {
        if (degree.value == input) {
          degreeText = degree.text;
        }
      });

      $log.debug(degreeText);

      return degreeText;
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('fillCustomFieldType', fillCustomFieldType);

  /** @ngInject */
  function fillCustomFieldType($compile) {
    var directive = {
      template: '<div class="form-group"><div class="row" ng-include="vm.getTemplateUrl()"></div></div>',
      restrict: 'E',
      scope: {
        type: '=',
        title: '=',
        fieldData: '=',
        metadata: '='
      },
      controller: FillCustomFieldTypeController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FillCustomFieldTypeController($log) {
      var vm = this;
      var type;

      // Display the delete button
      // vm.optionView = [];

      $log.debug(vm);

      vm.getTemplateUrl = function() {
        switch (vm.type) {
          case 'RADIO_BUTTON':
          // $log.debug('=== RADIO_BUTTON ===');
          // $log.debug(vm.fieldData);

            setRadioButton();
            return getUrl('radioButton');
          case 'TEXT':
            // $log.debug('=== TEXT ===');
            // $log.debug(vm.fieldData);
            return getUrl('text');
          default:
            return null;
        }
      };

      function setRadioButton() {
        if (!angular.isDefined(vm.metadata) || vm.metadata.length == 0) {
          $log.debug('push.....');
          vm.metadata = {
            options: [
              {
              }
            ]
          };

          $log.debug(vm.metadata);
        }

        vm.hoverDelete = function(index) {
          return option.showDelete = !option.showDelete;
        };
        vm.appendOption = function() {
          vm.metadata.options.push({
          });
        };

        vm.delete = function(index) {
          $log.debug('=== vm.delete() ===');
          $log.debug(index);
          vm.metadata.options.splice(index, 1);
        }
      }

      function getUrl(type) {
        return 'app/components/customFieldDirective/' + type + 'FilledFieldType.html';
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('customFieldTypePreview', customFieldTypePreview);

  /** @ngInject */
  function customFieldTypePreview($compile) {
    var directive = {
      template: '<ng-include src="vm.getTemplateUrl()"/>',
      restrict: 'E',
      scope: {
        type: '=',
        attribute: '='
      },
      controller: CustomFieldTypePreviewController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CustomFieldTypePreviewController() {
      var vm = this;

      vm.getTemplateUrl = function() {
        return 'app/components/customFieldDirective/' + vm.type + 'FieldTypePreview.html'
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('customFieldType', customFieldType);

  /** @ngInject */
  function customFieldType($compile) {
    var directive = {
      template: '<ng-include src="vm.getTemplateUrl()"/>',
      restrict: 'E',
      scope: {
        type: '=',
        metadata: '='
      },
      controller: CustomFieldTypeController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CustomFieldTypeController($log) {
      var vm = this;
      var type;

      // Display the delete button
      // vm.optionView = [];

      $log.debug(vm);

      vm.getTemplateUrl = function() {
        switch (vm.type) {
          case 'radioButton':
            $log.debug('=== radioButton ===');
            setRadioButton();
            return getUrl(vm.type);
          default:
            return null;
        }
      };

      function setRadioButton() {
        if (!angular.isDefined(vm.metadata) || vm.metadata.length == 0) {
          $log.debug('push.....');
          vm.metadata = {
            options: [
              {
              }
            ]
          };

          $log.debug(vm.metadata);
        }

        vm.hoverDelete = function(index) {
          return option.showDelete = !option.showDelete;
        };
        vm.appendOption = function() {
          vm.metadata.options.push({
          });
        };

        vm.delete = function(index) {
          $log.debug('=== vm.delete() ===');
          $log.debug(index);
          vm.metadata.options.splice(index, 1);
        }
      }

      function getUrl(type) {
        return 'app/components/customFieldDirective/' + type + 'FieldType.html';
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('customField', customField);

  /** @ngInject */
  function customField() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/customFieldDirective/customFieldDirective.html',
      scope: {
        data: '='
      },
      controller: CustomFieldDirectiveController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }

  /** @ngInject */
  function CustomFieldDirectiveController(
    $log,
    $stateParams,
    projectCustomField,
    CUSTOM_FIELD_TYPES
  ) {
    var vm = this;
    var projectId = $stateParams.projectId;
    vm.typeOptions = CUSTOM_FIELD_TYPES;
    vm.store = store;

    angular.element(document).ready(setFieldType);

    function store() {
      // vm.data['type'] = 'project_custom_field';
      vm.data['type'] = vm.type.value;
      $log.debug('customFieldData');
      $log.debug(vm.data);

      switch (vm.type.value) {
        case 'RADIO_BUTTON':
          setRadioButtonMetadataValue(vm.data.metadata);
          break;
      }

      removeDateTime();

      $log.debug('vm.data');
      $log.debug(vm.data);

      projectCustomField
        .storeOrUpdateByProjectId(vm.data, projectId);
    }

    function setRadioButtonMetadataValue(metadata) {
      angular.forEach(metadata.options, function(item, key) {
        item['value'] = key;
      });
    }

    function removeDateTime() {
      if (angular.isDefined(vm.data.created_at)) {
        delete vm.data.created_at;
      }

      if (angular.isDefined(vm.data.updated_at)) {
        delete vm.data.updated_at;
      }
    }

    function setFieldType() {
      $log.debug('=== setFieldType() ===');
      $log.debug(vm.data);
      if (angular.isDefined(vm.data.type)) {
        $log.debug('=== type is defined ===');

        angular.forEach(CUSTOM_FIELD_TYPES, function(type) {
          if (vm.data.type == type.value) {
            vm.type = type;
          }
        });
      } else {
        $log.debug('=== type is not defined ===');

        vm.type = {
          label: '文字',
          typeName: 'text',
          value: 'TEXT'
        };
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .filter('customFieldDataToText', customFieldDataToText);

  /** @ngInject */
  function customFieldDataToText($filter, $log) {
    var filter = function(input, type, metadata) {
      var transformedInput;

      switch (type) {
        case 'RADIO_BUTTON':
          transformRadioButton();

          break;
        case 'TEXT':
          transformedInput = input.value;

          break;
        default:
          transformedInput = 'NONE';
      }

      $log.debug('### type ###');
      $log.debug(type);
      $log.debug('### transformedInput ###');
      $log.debug(transformedInput);

      return transformedInput;

      function transformRadioButton() {
        $log.debug('=== transformRadioButton ===');
        $log.debug('### input ###');
        $log.debug(input);
        $log.debug('### metadata ###');
        $log.debug(metadata);

        angular.forEach(metadata.options, function(item) {
          $log.debug(item);

          if (item.value == input.option.value) {
            transformedInput = item.display_name;
            $log.debug('--- equal ---');
          }
        });
      }
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('authPrinciple', authPrinciple);

  /** @ngInject */
  function authPrinciple(vmsLocalStorage) {
    var service = {
      identity: identity
    };

    return service;

    function identity() {
      return vmsLocalStorage.jwtExists();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .directive('showAttendingProjects', showAttendingProjects);

  /** @ngInject */
  function showAttendingProjects() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/attendingProjectsDirective/showAttendingProjectDirective.html',
      scope: {
        memberId: '='
      },
      controller: ShowAttendingProjectsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }

  /** @ngInject */
  function ShowAttendingProjectsController($log, volunteer) {
    var vm = this;

    $log.debug("ShowAttendingProjectsController");

    volunteer.getAttendingProjects(vm.memberId)
      .then(function(attendingRecords) {
        $log.debug("getAttendingProjects().then()");

        vm.data = attendingRecords.data;

        $log.debug("vm.data");
        $log.debug(vm.data);
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('arrayHelpersService', arrayHelpersService);

  function arrayHelpersService(
    $log,
    lodash
  ) {
    var service = {
      getExistingIndexes: getExistingIndexes
    };

    function getExistingIndexes(origin, update) {
      $log.debug('getExistingIndexes');
      $log.debug(origin);
      $log.debug(update);

      var existingIndexes = [];

      angular.forEach(origin, function(value) {
        $log.debug('value');
        $log.debug(value);

        var index = lodash.findIndex(update, function(item) {
          return item.name == value.name;
        });

        $log.debug('index');
        $log.debug(index);

        if (index != -1) {
          $log.debug('found');
          $log.debug(index);
          existingIndexes.push(index);
        }
      });

      return existingIndexes;
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .factory('alertMessage', alertMessage);

  /** @ngInject */
  function alertMessage(
    $log
  ) {
    var service = {
      convertToValidationDanger: convertToValidationDanger,
      convertToDanger: convertToDanger
    };

    return service;

    function convertToValidationDanger(errors) {
      $log.debug("convertToValidationDanger()");

      var data = [];

      angular.forEach(errors, function(messages, fieldName) {
        var item = {
          field: fieldName,
          message: []
        };

        messages.forEach(function(message) {
          item.message.push('alert.danger.' + message);
        });

        this.push(item);
      }, data);

      var danger = {
        type: 'danger',
        data: data
      };

      return danger;
    }

    function convertToDanger(errors) {
      $log.debug("convertToDanger()");

      var message = [];

      errors.forEach(function(item) {
        message.push('alert.danger.' + item);
      });

      var danger = {
        type: 'danger',
        data: {
          message: message
        }
      };

      $log.debug(danger);

      return danger;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('vmsFrontend')
        .controller('AboutController', AboutController);


    function AboutController() {
        var vm = this;
        vm.aboutVMS = "志工管理系統(Volunteer Management System, VMS)";
    }
})();
(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, vmsLocalStorage, $rootScope, $state, $stateParams, $urlRouter, editableOptions) {
    editableOptions.theme = 'bs3';

    // Listen state check start event
    var stateChangeForAuthorizationCallback = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams) {
      $log.debug("=== $stateChangeStart ===");
      $log.debug("###### state debug ######");
      $log.debug(toState);
      $log.debug(toStateParams);
      $log.debug("##########");

      $rootScope.toState = toState;
    });

    var stateChangeLoggingError = $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
      $log.error("stateChangeLoggingError");
      $log.error(event)
      $log.error(error);
    });

    var urlRouterSyncDeregisteratinoCallback = $rootScope.$on('$locationChange', function(event) {
      event.preventDefault();
      $urlRouter.sync();
    });

    var scrollToTopPageCallback = $rootScope.$on('$stateChangeSuccess', function() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });




    $rootScope.$on('$destroy', stateChangeForAuthorizationCallback);
    $rootScope.$on('$destroy', urlRouterSyncDeregisteratinoCallback);
    $rootScope.$on('$destroy', scrollToTopPageCallback);
    $rootScope.$on('$destroy', stateChangeLoggingError);

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('site', {
        abstract: true,
        resolve: {
          authorize: function(userAuthentication, $log, $state) {
            $log.debug("=== authorize === ");
            var successCallback = function() {
              $log.debug('successCallback()');
            };
            var failureCallback = function() {
              $log.debug("failureCallback()");
              $state.go('login');
            };

            return userAuthentication.authorize()
              .then(successCallback)
              .catch(failureCallback);
          }
        }
      })
      .state('user', {
        parent: 'site',
        url: '/user',
      })
      .state('login', {
        url: '/login',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/login/userLogin.html',
            controller: 'UserLoginController',
            controllerAs: 'vm'
          }
        }
      })
      .state('registerPrivacy', {
        url: '/register-privacy',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/register/registerPrivacy.html'
          }
        }
      })
      .state('register', {
        url: '/register',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/register/userRegister.html',
            controller: 'UserRegisterController',
            controllerAs: 'vm'
          }
        }
      })
      .state('registerSuccess', {
        parent: 'site',
        url: '/register/success?last_name&email', // NEED to add paramters
        params: {
          last_name: {
            value: "志工" // default value
          },
          email: {
            value: "註冊" // default value
          }
        },
        views: {
          'mainContent@': {
            templateUrl: 'app/user/register/success/userRegisterSuccess.html',
            controller: 'UserRegisterSuccessController',
            controllerAs: 'vm'
          }
        }
      })
      .state('forgotPassword', {
        url: '/forgot-password',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/forgotPassword/forgotPassword.html',
            controller: 'ForgotPasswordController',
            controllerAs: 'vm'
          }
        }
      })
      .state('resetPassword', {
        url: '/reset-password?token&email',
        params: {
          token: {
            value: "none"
          },
          email: {
            value: "none"
          }
        },
        views: {
          'mainContent@': {
            templateUrl: 'app/user/resetPassword/resetPassword.html',
            controller: 'ResetPasswordController',
            controllerAs: 'vm'
          }
        }
      })
      .state('profile', {
        parent: 'site',
        url: '/profile',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/profile/show/showUserProfile.html',
            controller: 'ShowUserProfileController',
            controllerAs: 'vm'
          }
        }
      })
      .state('rootEditProfile', {
        parent: 'site',
        url: '/profile',
        views: {
          'mainContent@': {
            templateUrl: 'app/user/profile/update/updateUserProfile.html'
          }
        }
      })
      .state('rootEditProfile.edit', {
        url: '/edit',
        views: {
          'profileContent': {
            templateUrl: 'app/user/profile/update/updateAboutAndContact.html',
            controller: 'UpdateUserProfileController',
            controllerAs: 'vm'
          }
        }
      })
      .state('rootEditProfile.aboutContact', {
        url: '/edit/about',
        views: {
          'profileContent': {
            templateUrl: 'app/user/profile/update/updateAboutAndContact.html',
            controller: 'UpdateUserProfileController',
            controllerAs: 'vm'
          }
        }
      })
      .state('rootEditProfile.experienceEducation', {
        url: '/edit/experience-education',
        views: {
          'profileContent': {
            templateUrl: 'app/user/experienceAndEducation.html',
          },
          'experienceContent@rootEditProfile.experienceEducation': {
            templateUrl: 'app/user/experience/userExperience.html',
            controller: 'UserExperienceController',
            controllerAs: 'vm'
          },
          'educationContent@rootEditProfile.experienceEducation': {
            templateUrl: 'app/user/education/userEducation.html',
            controller: 'UserEducationController',
            controllerAs: 'vm'
          }
        }
      })
      .state('rootEditProfile.skillEquipment', {
        url: '/edit/skill-equipment',
        views: {
          'profileContent': {
            templateUrl: 'app/user/skillEquipment/edit/userEditSkillEquipment.html',
            controller: 'UserEditSkillEquipmentController',
            controllerAs: 'vm'
          }
        }
      })
      .state('rootEditProfile.changePassword', {
        url: '/change-password',
        views: {
          'profileContent': {
            templateUrl: 'app/user/changePassword/changePassword.html',
            controller: 'ChangePasswordController',
            controllerAs: 'vm'
          }
        }
      })
      .state('emailVerification', {
        parent: 'site',
        url: '/email-verification?email&verification_token',
        params: {
          email: {
            value: ""
          },
          verification_token: {
            value: ""
          }
        },
        views: {
          'mainContent@': {
            templateUrl: 'app/user/email/verify/verifyUserEmail.html',
            controller: 'VerifyUserEmailController',
            controllerAs: 'vm'
          }
        }
      })
      .state('introduction', {
        url: '/',
        views: {
          'introductionContent@': {
            templateUrl: 'app/about/about.html',
            controller: 'AboutController',
            controllerAs: 'vm'
          }
        }
      })
      .state('copyright', {
        parent: 'site',
        url: '/copyright',
        views: {
          'mainContent@': {
            templateUrl: 'app/copyrightPage/copyright.html'
          }
        }
      })
      .state('createProject', {
        parent: 'site',
        url: '/projects/create',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/create/createProject.html',
            controller: 'CreateProjectController',
            controllerAs: 'vm'
          }
        }
      })
      .state('managedProjectList', {
        parent: 'site',
        url: '/projects/show/managed',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/list/managed/managedProjectList.html',
            controller: 'ManagedProjectListController',
            controllerAs: 'vm'
          }
        }
      })
      .state('attendingProjectList', {
        parent: 'site',
        url: '/projects/show/attending',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/list/attending/attendingProjectList.html',
            controller: 'AttendingProjectListController',
            controllerAs: 'vm'
          }
        }
      })
      .state('project', {
        parent: 'site',
        url: '/manage-project',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/projectTplPage.html'
          }
        }
      })
      .state('project.show', {
        url: '/show/:projectId',
        views: {
          'panel': {
            templateUrl: 'app/project/panel/projectPanel.html',
            controller: 'ProjectPanelController',
            controllerAs: 'vm'
          },
          'container': {
            templateUrl: 'app/project/detail/managed/managedProjectDetail.html',
            controller: 'ManagedProjectDetailController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          projectData: getProject,
          members: function($stateParams, vmsClient) {
            var id = $stateParams.projectId;
            var onSuccess = function(response) {
              return response.data;
            };

            return vmsClient.getProjectMembers(id)
              .then(onSuccess);
          }
        }
      })
      .state('project.edit', {
        url: '/edit/:projectId',
        views: {
          'panel': {
            templateUrl: 'app/project/panel/projectPanel.html',
            controller: 'ProjectPanelController',
            controllerAs: 'vm'
          },
          'container': {
            templateUrl: 'app/project/edit/editProject.html',
            controller: 'EditProjectController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          projectData: getProject,
          members: function($stateParams, vmsClient) {
            var id = $stateParams.projectId;
            var onSuccess = function(response) {
              return response.data;
            };

            return vmsClient.getProjectMembers(id)
              .then(onSuccess);
          }
        }
      })
      .state('project.manageCustomField', {
        url: '/:projectId/manage-custom-field',
        views: {
          'panel': {
            templateUrl: 'app/project/panel/projectPanel.html',
            controller: 'ProjectPanelController',
            controllerAs: 'vm'
          },
          'container': {
            templateUrl: 'app/project/customField/manage/manageProjectCustomField.html',
            controller: 'ManageProjectCustomFieldsController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          projectData: getProject,
          members: function($stateParams, vmsClient) {
            var id = $stateParams.projectId;
            var onSuccess = function(response) {
              return response.data;
            };

            return vmsClient.getProjectMembers(id)
              .then(onSuccess);
          }
        }
      })
      .state('project.manageMembers', {
        url: '/:projectId/manage-members',
        views: {
          'panel': {
            templateUrl: 'app/project/panel/projectPanel.html',
            controller: 'ProjectPanelController',
            controllerAs: 'vm'
          },
          'container': {
            templateUrl: 'app/project/member/list/projectMemberList.html',
            controller: 'ProjectMemberListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          projectData: getProject,
          membersData: function($stateParams, vmsClient) {
            var id = $stateParams.projectId;
            var onSuccess = function(response) {
              return response.data;
            };

            return vmsClient.getAllMembersCustomFieldData(id)
              .then(onSuccess);
          }
        }
      })
      .state('showAllProjects', {
        parent: 'site',
        url: '/projects/show/all',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/list/all/allProjectList.html',
            controller: 'AllProjectListController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          projects: function(project, $log) {
            $log.debug("projectList resolve");

            var onSuccess = function(value) {
              $log.debug("projectList onSuccess()");
              $log.debug(value);

              return value.data;
            };
            var onError = function() {
              $log.debug("projectList onError()");
            };

            return project.getAll()
              .then(onSuccess)
              .catch(onError);
          }
        }
      })
      .state('projectDetail', {
        parent: 'site',
        url: '/projects/:id/show',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/detail/public/projectDetail.html',
            controller: 'ProjectDetailController',
            controllerAs: 'vm'
          }
        }
      })
      .state('fillProjectCustomFieldData', {
        parent: 'site',
        url: '/projects/:projectId/fill-custom-fields',
        views: {
          'mainContent@': {
            templateUrl: 'app/project/customField/fill/fillCustomFields.html',
            controller: 'FillCustomFieldsController',
            controllerAs: 'vm'
          },
        }
      });

    $urlRouterProvider.otherwise('/');

    function getProject($stateParams, $log, project) {
      var id = $stateParams.projectId;
      var onSuccess = function(value) {
        return value;
      };

      return project.getById(id).then(onSuccess);
    }
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('fieldName', {
      first_name: '姓氏',
      last_name: '名字',
      username: '帳號',
      password: '密碼',
      email: '電子郵件'
    })
    .constant('defaultAvatarPath', './assets/images/profile-default-avatar.png')
    .constant('LOCAL_STORAGE_CONFIG', {
      keys: {
        jwt: 'jwt_token',
        userName: 'user_name',
        lastName: 'last_name',
        role: 'role',
        avatarPath: 'avatar_path'
      }
    })
    .constant('BROADCAST_EVENTS_LIST', {
      AUTHENTICATED_SUCCESS_EVENT: '$authenticatedSuccessEvent',
      AUTHENTICATED_FAILURE_EVENT: '$authenticatedFailureEvent'
    })
    .constant('cities', [{
      id: 2,
      name_zh_tw: '臺北市'
    }, {
      id: 12,
      name_zh_tw: '新北市'
    }, {
      id: 22,
      name_zh_tw: '桃園縣'
    }, {
      id: 32,
      name_zh_tw: '臺中市'
    }, {
      id: 42,
      name_zh_tw: '高雄市'
    }, {
      id: 52,
      name_zh_tw: '臺南市'
    }, {
      id: 62,
      name_zh_tw: '新竹市'
    }, {
      id: 72,
      name_zh_tw: '嘉義市'
    }, {
      id: 82,
      name_zh_tw: '基隆市'
    }, {
      id: 92,
      name_zh_tw: '新竹市'
    }, {
      id: 102,
      name_zh_tw: '苗栗市'
    }, {
      id: 112,
      name_zh_tw: '彰化縣'
    }, {
      id: 122,
      name_zh_tw: '南投縣'
    }, {
      id: 132,
      name_zh_tw: '雲林縣'
    }, {
      id: 142,
      name_zh_tw: '嘉義縣'
    }, {
      id: 152,
      name_zh_tw: '屏東縣'
    }, {
      id: 162,
      name_zh_tw: '宜蘭縣'
    }, {
      id: 172,
      name_zh_tw: '花蓮縣'
    }, {
      id: 182,
      name_zh_tw: '臺東線'
    }, {
      id: 192,
      name_zh_tw: '金門縣'
    }, {
      id: 202,
      name_zh_tw: '連江縣'
    }, {
      id: 212,
      name_zh_tw: '澎湖縣'
    }

    ])
    .constant('PERMISSION_OPTIONS', [
      {
        name: 'project.permissions.choose_permission',
        value: ''
      },
      {
        name: 'project.permissions.all_users',
        value: 0
      },
      {
        name: 'project.permissions.registered_users',
        value: 1
      },
      {
        name: 'project.permissions.members',
        value: 2
      }
    ])
    .constant('EDUCATION_DEGREES', [
      {
        value: 1,
        text: 'education.degrees.elementary'
      },
      {
        value: 2,
        text: 'education.degrees.junior'
      },
      {
        value: 3,
        text: 'education.degrees.high'
      },
      {
        value: 4,
        text: 'education.degrees.bachelor'
      },
      {
        value: 5,
        text: 'education.degrees.master'
      },
      {
        value: 6,
        text: 'education.degrees.phd'
      }
    ])
    .constant('CUSTOM_FIELD_TYPES', [
      {
        label: '文字',
        typeName: 'text',
        value: 'TEXT'
      },
      {
        label: '單選按鈕',
        typeName: 'radioButton',
        value: 'RADIO_BUTTON'
      }
    ])
    .constant('FROALA_OPTIONS', {
      language: 'en_gb',
      heightMin: 200,
      heightMax: 500
    });

})();


(function() {
  'use strict';

  angular
    .module('vmsFrontend')
    .config(config);

  /** @ngInject */
  function config(
    $logProvider,
    toastrConfig,
    localStorageServiceProvider,
    $httpProvider,
    $translateProvider) {
    // Set local storage prefix name
    localStorageServiceProvider.setPrefix('vms');

    // Http Interceptors
    var interceptors = [
      'apiKeyHttpInterceptor',
      'jwtHttpInterceptor',
      'refreshJwtHttpInterceptor'
    ];

    // Add $http interceptors
    for (var i = 0; i < interceptors.length; i++) {
      $httpProvider.interceptors.push(interceptors[i]);
    }

    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // translation
    $translateProvider
      .useStaticFilesLoader({
        'prefix': 'assets/lang/locale-',
        'suffix': '.json'
      });

    if (angular.isDefined(window.navigator.language)) {
      $translateProvider
        .preferredLanguage(window.navigator.language);
    }
  }

})();

angular.module("vmsFrontend.config", [])

.constant("config", {
	"apiBaseUrl": "https://vms-dev.herokuapp.com/api",
	"apiKey": "581dba93a4dbafa42a682d36b015d8484622f8e3543623bec5a291f67f5ddff1"
})

;
angular.module("vmsFrontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div class=header-basic><h1>關於志工管理系統</h1><h2>All for one, one for all.</h2></div><div class=container><div id=introduction-container class=row><!-- <div class=\"col-md-12\">\n			<h4 class=\"text-center\">透過網路，每個人都可以成為志工，透過網路救災，每個人都可以為這個世界貢獻一份心力。</h4>\n			<h4 class=\"text-center\">資料、資訊、感知、決策、知識，我們透過世界傳遞智慧，透過傳遞智慧改變世界。</h4>\n		</div> --><div class=\"col-md-6 col-xs-12\"><uib-carousel active=active interval=2500 no-wrap=noWrapSlides><uib-slide><img ng-src=./assets/images/2004-tsunami.jpg style=\"margin:auto; height: 290px\"><div class=carousel-caption><h4>蘇門答臘地震</h4><p>2004年12月26日，規模9.3大地震侵襲印尼，引發災難性大海嘯，造成逾29萬人喪命，印度與斯里蘭卡工程師開發自由開放軟體：SAHANA，以整合救災資源</p></div></uib-slide><uib-slide><img ng-src=https://c1.staticflickr.com/3/2363/1515287285_1c1fd6a9b1_o.jpg style=\"margin:auto; height: 290px\"><div class=carousel-caption><h4>肯亞災難</h4><p>2007年12月27日，肯亞總統選舉後發生暴動，逾千人喪命，25萬人流離失所，肯亞工程師開發自由開放系統：USHAHIDI，蒐集各類災情資訊</p></div></uib-slide><uib-slide><img ng-src=https://c1.staticflickr.com/1/513/19445213576_7e0d9312d1_b.jpg style=\"margin:auto; height: 290px\"><div class=carousel-caption><h4>海地、尼泊爾地震</h4><p>2010年1月12日，海地發生7級大地震、2015年5月12日，尼泊爾發生同樣7級大地震，這兩次大地震，各國網友透過開放街圖(OpenStreetMap)繪製地圖協助救災</p></div></uib-slide></uib-carousel><!-- <div class=\"thumbnail\">\n				<img src=\"./assets/images/2004-tsunami.jpg\">\n				<div class=\"caption\">\n					<h4>蘇門答臘地震</h4>\n					<p>2004年12月26日，規模9.3大地震侵襲印尼，引發災難性大海嘯，造成逾29萬人喪命，印度與斯里蘭卡工程師開發自由開放軟體：SAHANA，以整合救災資源</p>\n				</div>\n			</div> --></div><div class=\"col-md-6 col-xs-12\"><h4>透過網路，每個人都可以成為志工，透過網路救災，每個人都可以為這個世界貢獻一份心力。</h4><h4>資料、資訊、感知、決策、知識，我們透過世界傳遞智慧，透過傳遞智慧改變世界。</h4><div class=row><div class=\"col-md-12 col-xs-12\"><div style=\"margin-top: 30px\"><button class=\"btn btn-lg btn-primary center-block\" ui-sref=registerPrivacy>加入我們</button><p class=text-center><em>點擊上面按鈕加入我們</em></p></div></div></div></div><!-- <div class=\"col-md-4 col-xs-12\">\n	 		<div class=\"thumbnail\">\n				<img src=\"https://c1.staticflickr.com/3/2363/1515287285_1c1fd6a9b1_o.jpg\">\n				<div class=\"caption\">\n					<h4>肯亞災難</h4>\n					<p>2007年12月27日，肯亞總統選舉後發生暴動，逾千人喪命，25萬人流離失所，肯亞工程師開發自由開放系統：USHAHIDI，蒐集各類災情資訊</p>\n				</div>\n			</div>\n		</div> --><!-- <div class=\"col-md-5 col-md-offset-1 col-xs-12\">\n			 <div class=\"thumbnail\">\n				<img src=\"https://c1.staticflickr.com/1/513/19445213576_7e0d9312d1_b.jpg\">\n				<div class=\"caption\">\n					<h4>海地、尼泊爾地震</h4>\n					<p>2010年1月12日，海地發生7級大地震、2015年5月12日，尼泊爾發生同樣7級大地震，這兩次大地震，各國網友透過開放街圖(OpenStreetMap)繪製地圖協助救災</p>\n				</div>\n			</div>\n		 </div> --><!-- <div class=\"col-md-12\">\n			<button class=\"btn btn-lg btn-primary center-block\" ui-sref=\"registerPrivacy\">成為志工</button>\n			<p class=\"text-center\"><em>點擊上面按鈕成為志工</em></p>\n		</div> --></div></div><div class=ad-container><div><img class=img-responsive src=http://www.earth.sinica.edu.tw/images/bg-top.jpg></div><div class=ad-container-text><h2>合作單位 - 地球科學研究所 <span class=\"glyphicon glyphicon-globe\" aria-hidden=true></span></h2><h3>台灣的地震現況</h3><p>台灣位在歐亞與菲律賓海板塊之間的活動聚合邊界上，地殼變形劇烈，地震活動頻繁。藉由高品質的地震監測網，氣象局有能力在地震發生後的 20 秒內掌握地震的位置、規模和各地震度等資訊；我們也反演台灣即時寬頻波形記錄，快速取得地震斷層的錯動機制；另外台大廣布加速度計，可大幅提高觀測震度的空間解析度。</p><h3>我們的目的</h3><p>在中研院的主題計畫下，我們已經建置完成一套整合氣象局地震速報與學界即時科學成果的資訊系統，作為科學討論與教育推廣的平台。目前，我們著重在開發群眾外包 (crowdsourcing) 系統，收集群眾資訊，並將這些透過網路回報的資訊轉換成民眾可理解的「網路震度」， 提高民眾對地震災害的危機意識，並推廣公民地震學 (citizen seismology)。</p><h3>想要有您的參與</h3><p>我們將招募熱血專業志工，訓練如何辨識與地震相關的地質災害並進行科學描述，並與資訊科學所合作開發志工管理系統，在顯著地震發生後調度志工在安全的情況下回報地震地表災害的科學參數，協助斷定對應的孕震構造與評估後續的潛在危害。這是第一次由學界主導，在地震時和地震後收集群眾報告，彌補觀測系統的不足之處，並充實地震科學的現地資訊，提供防災應變參考。</p></div><a class=\"btn btn-primary btn-lg\" target=_blank href=http://tec.earth.sinica.edu.tw/new_web/workshop>瀏覽專案</a></div><div class=flex-container><h2>Volunteer Management System, VMS</h2><div id=feature-text><p><span class=\"glyphicon glyphicon-wrench\" aria-hidden=true></span> 志工管理系統 (Volunteer Management System, VMS) 能協助專案管理員在志工外包專案中有效率且彈性的管理志工。每一位專案管理員對於志工的管理需求可能都不同，志工管理系統最大的特點將會是靈活與彈性，專案管理員將可以自由地定義需要的志工特點，也可以依照自己的管理需求選擇所需要的功能模組。</p><p><span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> 志工管理系統將會是開放原始碼軟體，有需求的單位可以自建版本之外，也可提供直接的網頁操作，若單位已擁有自己的災害平台，也可直接串接志工管理系統所提供的功能模組。</p></div></div>");
$templateCache.put("app/copyrightPage/copyright.html","<div id=main-content class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12\"><h1>版權宣告</h1><hr class=hr><p class=lead>以下為使用他人之著作</p><table class=\"table table-striped\"><thead><tr><th>著作名稱</th><th>著作</th><th>作者/來源</th><th>授權方式</th></tr></thead><tbody><tr><td>2004-tsunami.jpg</td><td><img src=./assets/images/2004-tsunami.jpg width=200></td><td>David Rydevik (email: david.rydevik@gmail.com), Stockholm, Sweden. <a href=https://en.wikipedia.org/wiki/File:2004-tsunami.jpg target=_blank>來源網址</a></td><td>Public domain</td></tr><tr><td>ODM Portrait</td><td><img src=https://c1.staticflickr.com/3/2363/1515287285_1c1fd6a9b1_o.jpg width=200></td><td>DEMOSH <a href=https://www.flickr.com/photos/44222307@N00/1515287285/ target=_blank>來源網址</a></td><td>CC BY 2.0</td></tr><tr><td>\"Die Suche nach Überlebenden\" Nepal April/Mai 2015</td><td><img src=https://c1.staticflickr.com/1/513/19445213576_7e0d9312d1_b.jpg width=200></td><td>Wiesbaden112.de <a href=https://www.flickr.com/photos/feuerwehrwiesbaden/19445213576 target=_blank>來源網址</a></td><td>CC BY-NC-ND 2.0</td></tr></tbody></table></div>");
$templateCache.put("app/project/manageProjectMembers.html","<div class=modal-header><h3 class=modal-title>管理專案成員</h3></div><div class=modal-body></div><div class=modal-footer><button class=\"btn btn-danger\" type=button ng-click=vm.ok()>確認刪除帳號</button> <button class=\"btn btn-default\" type=button ng-click=vm.cancel()>取消</button></div>");
$templateCache.put("app/project/projectMemberVolunteerList.html","<div class=row><div ng-repeat=\"member in vm.membersList.data track by $index\"><div class=\"col-md-1 col-lg-1\">{{ member.attributes.username }}</div><div class=\"col-md-1 col-lg-1\">{{ member.first_name }} {{ member.last_name}}</div></div></div>");
$templateCache.put("app/project/projectMembers.html","");
$templateCache.put("app/project/projectTplPage.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=row><div class=col-md-3><div class=\"anim-in-out anim-fade\" data-anim-speed=1000 ui-view=panel></div></div><div class=col-md-9><div class=\"anim-in-out anim-fade\" data-anim-speed=1000 ui-view=container></div></div></div></div>");
$templateCache.put("app/user/experienceAndEducation.html","<div class=\"anim-in-out anim-fade\" data-anim-speed=1000 ui-view=experienceContent></div><div class=\"anim-in-out anim-fade\" data-anim-speed=1000 ui-view=educationContent></div>");
$templateCache.put("app/components/attendingProjectsDirective/showAttendingProjectDirective.html","<div class=row><div class=\"col-md-12 col-lg-12\"><table class=\"table table-striped\"><tr><th>專案名稱</th><th>加入時間</th></tr><tr ng-repeat=\"attending in vm.data\"><td>{{ attending.project.name }}</td><td>{{ attending.attending_at.date | formatDateTime }}</td></tr></table></div></div>");
$templateCache.put("app/components/customFieldDataToTextFilter/customFieldDataToText.html","");
$templateCache.put("app/components/customFieldDirective/customFieldDirective.html","<div class=row ng-mouseenter=\"actionVisible=true\" ng-mouseleave=\"actionVisible=false\"><div class=\"project-custom-field-preview left-line col-md-12 col-lg-12\"><div class=row-eq-height><custom-field-type-preview class=\"col-md-10 col-lg-10\" type=vm.type.typeName attribute=vm.data></custom-field-type-preview><div class=\"col-md-2 col-lg-2\"><div class=custom-field-action ng-show=actionVisible><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true ng-click=\"contentVisible=true\"></span></div></div></div></div><div class=\"project-custom-field-wrapper col-md-12 col-lg-12\" ng-show=contentVisible><div class=project-custom-field-content><form><div class=row><div class=\"form-group col-md-12 col-lg-12\"><div class=\"row row-eq-height\"><label class=\"control-label col-md-2 col-lg-2\" for=field-name>欄位名稱</label><div class=\"col-md-10 col-lg-10\"><input id=field-name type=text class=form-control placeholder=欄位名稱 ng-model=vm.data.name required></div></div></div></div><div class=row><div class=\"form-group col-md-12 col-lg-12\"><div class=\"row row-eq-height\"><label class=\"col-md-2 col-lg-2 control-label\" for=field-description>欄位描述</label><div class=\"col-md-10 col-lg-10\"><input id=field-description type=text class=form-control placeholder=欄位描述 ng-model=vm.data.description required></div></div></div></div><div class=row><div class=\"form-group col-md-6 col-lg-6\"><div class=row-eq-height><label class=\"col-md-4 col-lg-4 control-label\" for=field-type>欄位類型</label><div class=\"col-md-8 col-lg-8\"><select name=field-type id=field-type class=form-control ng-options=\"option.label for option in vm.typeOptions\" ng-model=vm.type></select></div></div></div><div class=\"form-group col-md-6 col-lg-6\"><div class=row-eq-height><label class=\"col-md-4 col-lg-4 control-label\" for=field-required>是否必填</label><div class=\"col-md-8 col-lg-8\"><div><div class=\"radio row-eq-height\"><label class=\"col-lg-6 col-md-6\"><input type=radio name=field-required ng-model=vm.data.required ng-value=true> 是</label><label class=\"col-lg-6 col-md-6\"><input type=radio name=field-required ng-model=vm.data.required ng-value=false> 否</label></div></div></div></div></div><custom-field-type type=vm.type.typeName metadata=vm.data.metadata></custom-field-type></div><div class=row><div class=\"col-lg-12 col-md-12\"><div class=\"btn-group pull-right\" role=group aria-label=...><button class=\"btn btn-sm btn-primary\" ng-click=\"contentVisible=false\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 取消</button> <button class=\"btn btn-sm btn-primary\" ng-click=vm.store()><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=true></span> 儲存</button><!-- <button class=\"btn btn-sm btn-danger\">\n                <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span> 移除\n              </button> --></div></div></div></form></div></div></div>");
$templateCache.put("app/components/customFieldDirective/radioButtonFieldType.html","<div class=\"form-group col-md-12 col-lg-12\"><div class=row><div class=\"col-md-2 col-lg-2\"><label class=control-label for=field-meta>選項</label></div><div class=\"col-md-4 col-lg-4\"><div class=row><div class=\"col-md-12 col-lg-12\" ng-repeat=\"option in vm.metadata.options track by $index\" ng-mouseenter=\"visible=true\" ng-mouseleave=\"visible=false\"><div class=row><div class=\"col-md-9 col-lg-9 v-center\"><input id=field-meta type=text class=form-control placeholder=選項 ng-model=vm.metadata.options[$index].display_name required></div><div class=\"col-md-2 col-lg-2 v-center\"><div><span ng-show=visible ng-click=vm.delete($index) class=\"glyphicon glyphicon-remove\"></span></div></div></div></div></div><div class=\"row add-new-option-section\"><div class=\"col-md-4 col-lg-4\"><div class=row><div class=\"col-md-10 col-lg-10 text-center\"><i class=\"text-center glyphicon glyphicon-plus\" ng-click=vm.appendOption()></i></div></div></div></div></div></div></div>");
$templateCache.put("app/components/customFieldDirective/radioButtonFieldTypePreview.html","<div class=project-custom-field-preview-section><form><div class=row><div class=\"form-group col-md-12 col-lg-12\"><div class=\"row row-eq-height\"><label class=\"col-md-offset-1 col-lg-offset-1 col-md-2 col-lg-2 control-label\">{{ vm.attribute.name }}</label><div class=\"col-md-8 col-lg-8\"><div ng-repeat=\"option in vm.attribute.metadata.options\"><label><input type=radio name=optionsRadios id=optionsRadios1> {{ option.display_name }}</label></div></div></div></div></div></form></div>");
$templateCache.put("app/components/customFieldDirective/radioButtonFilledFieldType.html","<label class=\"control-label col-md-2 col-lg-2\">{{ vm.title }}</label><div class=\"col-md-10 col-lg-10\"><div ng-repeat=\"option in vm.metadata.options\"><label class=radio-inline><input type=radio name=\"{{ vm.title }}\" ng-value=option.value ng-model=vm.fieldData.option.value> {{ option.display_name }}</label></div></div>");
$templateCache.put("app/components/customFieldDirective/textFieldTypePreview.html","<div class=project-custom-field-preview-section><form><div class=row><div class=\"form-group col-md-12 col-lg-12\"><div class=row><label class=\"col-md-offset-1 col-lg-offset-1 col-md-2 col-lg-2 control-label\">{{ vm.attribute.name }}</label><div class=\"col-md-7 col-lg-7\"><input type=text class=form-control></div></div></div></div></form></div>");
$templateCache.put("app/components/customFieldDirective/textFilledFieldType.html","<label class=\"control-label col-md-2 col-lg-2\">{{ vm.title }}</label><div class=\"col-md-10 col-lg-10\"><input type=text class=form-control placeholder=\"{{ vm.title }}\" ng-model=vm.fieldData.value required></div>");
$templateCache.put("app/components/editableProjectHyperlinksDirective/editableProjectHyperlinksDirective.html","<div class=row><div class=\"form-group col-md-12 col-lg-12\" ng-repeat=\"hyperlink in vm.data\"><div class=row ng-mouseenter=\"visible=true\" ng-mouseleave=\"visible=false\"><div class=\"col-md-3 col-lg-4\"><input type=text class=form-control placeholder=連結名稱 ng-model=hyperlink.name required></div><div class=\"col-md-7 col-lg-7\"><input type=text class=form-control placeholder=連結網址 ng-model=hyperlink.link required></div><div class=\"col-md-2 col-lg-1\"><span ng-show=visible class=\"glyphicon glyphicon-remove\" aria-hidden=true ng-click=vm.remove($index)></span></div></div></div><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"col-md-12 col-lg-12\"><a class=\"btn btn-default\" ng-click=vm.append()>新增連結</a></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-default navbar-fixed-top\" role=navigation><div class=container><div class=navbar-header><a class=\"navbar-brand color\" ui-sref=introduction>VMS</a> <button type=button class=navbar-toggle ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div id=navbar class=\"navbar-collapse collapse\" collapse=navCollapsed><ul class=\"nav navbar-nav navbar-right\"><li><a ng-hide=vm.userAuthentication.isAuthenticated() ui-sref=registerPrivacy>註冊</a></li><li><a ng-hide=vm.userAuthentication.isAuthenticated() ui-sref=login>登入</a></li><li ng-show=vm.userAuthentication.isAuthenticated() uib-dropdown><a uib-dropdown-toggle>專案<span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=vm.isManagerRole() role=menuitem><a ui-sref=createProject>新增專案</a></li><li ng-if=vm.isManagerRole() role=menuitem><a ui-sref=managedProjectList>我的專案</a></li><li ng-if=vm.isVolunteerRole()><a ui-sref=showAllProjects>所有專案</a></li><li ng-if=vm.isVolunteerRole()><a ui-sref=attendingProjectList>已參與的專案</a></li></ul></li><li ng-show=vm.userAuthentication.isAuthenticated() uib-dropdown><a id=navbar-profile aria-labelledby=nav-profile-tempate-url uib-dropdown-toggle><img src=\"{{ vm.getAvatarPath() }}\" class=img-circle width=20px height=20px> {{ vm.getLastName() }} <span class=caret></span></a><ul class=dropdown-menu aria-labelledby=navbar-profile><li><a ui-sref=profile>我的資料</a></li><li role=separator class=divider></li><li class=disabled><a>身份：{{ vm.getRole() | translate }}</a></li><li ng-if=vm.isManagerRole() role=menuitem><a ng-click=vm.switchToVolunteer()>切換為志工</a></li><li ng-if=vm.isVolunteerRole()><a ng-click=vm.switchToManager()>切換為專案管理員</a></li><li role=separator class=divider></li><li><a ng-click=vm.logout()>登出</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/components/projectHyperlinksDirective/projectHyperlinksDirective.html","<div class=row><div class=\"form-group col-md-12 col-lg-12\" ng-repeat=\"hyperlink in vm.data\"><div class=row><div class=\"col-md-4 col-lg-4\">{{ hyperlink.name }}</div><div class=\"col-md-8 col-lg-8\"><span ng-bind-html=\"hyperlink.link | linky\"></span></div></div></div></div>");
$templateCache.put("app/components/vmsMessageDirective/vmsMessageDirective.html","<uib-alert ng-repeat=\"alert in vm.data\" type={{alert.type}} dismiss-on-timeout=alert.timeout><div ng-if=vm.isArray(alert.data) ng-repeat=\"data in alert.data\"><ul><li>{{ data.field | translate }}<ng-repeat ng-repeat=\"message in data.message\">{{ message | translate }}{{ $last ? \'\' : \', \' }}</ng-repeat></li></ul></div><div ng-if=!vm.isArray(alert.data)><ul ng-if=vm.isArray(alert.data.message)><ng-repeat ng-repeat=\"message in alert.data.message\"><li>{{ alert.data.field | translate }} {{ message | translate }}</li></ng-repeat></ul><p ng-if=!vm.isArray(alert.data.message)>{{ alert.data.field | translate }} {{ alert.data.message | translate }}</p></div></uib-alert>");
$templateCache.put("app/project/create/createProject.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>新增專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=\"alert alert-danger\" role=alert ng-show=vm.errorMsg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>Error:</span> {{ vm.errorMsg }}</div><form><h2>基本資訊</h2><hr><div id=profile-basic class=\"profile-section row\"><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=name class=\"control-label col-md-2 col-lg-4\">名稱</label><div class=\"col-md-10 col-lg-8\"><input type=text class=form-control id=name placeholder=名稱 ng-model=vm.project.name required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=organization class=\"control-label col-md-2 col-lg-4\">組織名稱</label><div class=\"col-md-10 col-lg-8\"><input type=text class=form-control id=organization placeholder=組織名稱 ng-model=vm.project.organization required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=permission class=\"control-label col-md-2 col-lg-4\">瀏覽權限<span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true popover-title=\"{{ \'tips\' | translate }}\" uib-popover-template=\"\'projectPermissionExplanationBody.html\'\" popover-placement=bottom popover-trigger=mouseenter></span></label><div class=\"col-md-10 col-lg-8\"><select name=permission id=permission class=form-control ng-model=vm.project.permission><option ng-repeat=\"option in vm.permissionOptions\" value=\"{{ option.value }}\">{{ option.name | translate }}</option></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=permission class=\"control-label col-md-2 col-lg-4\"></label><div class=\"col-md-10 col-lg-8\" popover-title=\"{{ \'tips\' | translate }}\" uib-popover-template=\"\'projectPublishExplanationBody.html\'\" popover-placement=bottom popover-trigger=mouseenter><label class=radio-inline><input type=radio name=permission ng-value=true ng-model=vm.project.is_published> 發布</label><label class=radio-inline><input type=radio name=permission ng-value=false ng-model=vm.project.data.attributes.is_published> 不發佈</label></div></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=hyperlinks class=\"control-label col-md-1 col-lg-2\">相關連結</label><editable-project-hyperlinks class=\"col-md-11 col-lg-10\" projectid=\"\" data=vm.hyperlinks></editable-project-hyperlinks></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=description class=\"control-label col-md-1 col-lg-1\">說明</label><div class=\"col-md-11 col-lg-10 col-lg-offset-1\"><textarea froala=vm.froalaOptions class=form-control id=description ng-model=vm.project.description rows=4></textarea></div></div></div><div class=\"row profile-section\"><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\" ng-click=vm.create()>送出</button></div><div class=col-md-5></div></div></div></form></div><script type=text/ng-template id=projectPermissionExplanationBody.html><div>\n			{{ \'project.permission_explanation.body\' | translate }}\n			<ul>\n				<li>{{ \'project.permission_explanation.all_users\' | translate }}</li>\n				<li>{{ \'project.permission_explanation.registered_users\' | translate }}</li>\n				<li>{{ \'project.permission_explanation.members\' | translate }}</li>\n			</ul>\n    </div></script><script type=text/ng-template id=projectPublishExplanationBody.html><div>\n			{{ \'project.publish_explanation.body\' | translate }}\n    </div></script>");
$templateCache.put("app/project/edit/editProject.html","<div class=\"alert alert-danger\" role=alert ng-show=vm.errorMsg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>Error:</span> {{ vm.errorMsg }}</div><form><span class=h2-inline>修改</span><hr><div id=profile-basic class=\"profile-section row-eq-height\"><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=name class=\"control-label col-md-12 col-lg-4\">名稱</label><div class=\"col-md-12 col-lg-8\"><input type=text class=form-control id=name placeholder=名稱 ng-model=vm.project.name required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=organization class=\"control-label col-md-12 col-lg-4\">組織名稱</label><div class=\"col-md-12 col-lg-8\"><input type=text class=form-control id=organization placeholder=組織名稱 ng-model=vm.project.organization required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=permission class=\"control-label col-md-12 col-lg-4\">權限</label><div class=\"col-md-12 col-lg-8\"><select name=permission id=permission class=form-control ng-options=\"option.value as option.name | translate for option in vm.permissionOptions\" ng-model=vm.project.permission></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><div class=\"col-md-12 col-lg-8 col-lg-offset-4 center-block\"><label class=radio-inline><input type=radio name=permission ng-value=true ng-model=vm.project.is_published> 發布</label><label class=radio-inline><input type=radio name=permission ng-value=false ng-model=vm.project.is_published> 不發佈</label></div></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=hyperlinks class=\"control-label col-md-12 col-lg-2\">相關連結</label><editable-project-hyperlinks class=\"col-md-12 col-lg-10\" project-id=vm.project.id data=vm.hyperlinks></editable-project-hyperlinks></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=description class=\"control-label col-md-12 col-lg-2\">說明</label><div class=\"col-md-12 col-lg-10\"><textarea froala=vm.froalaOptions class=form-control id=description style=\"min-width: 100%\" ng-model=vm.project.description rows=10></textarea></div></div></div><div class=\"row profile-section\"><div class=\"col-md-12 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\" ng-click=vm.update()>送出</button></div><div class=col-md-5></div></div></div></form>");
$templateCache.put("app/project/panel/projectPanel.html","<div class=\"panel panel-default\"><div class=panel-heading><b>專案</b></div><ul class=list-group><li class=list-group-item ng-show=vm.isCreator()><a ui-sref=\"project.show({ projectId: vm.project.id })\">查看</a></li><li class=list-group-item ng-show=vm.isCreator()><a ui-sref=\"project.edit({ projectId: vm.project.id })\">修改</a></li><li class=list-group-item ng-show=vm.isCreator()><a ui-sref=\"project.manageMembers({ projectId: vm.project.id })\">成員管理</a></li><li class=list-group-item ng-show=vm.isCreator()><a ui-sref=\"project.manageCustomField({ projectId: vm.project.id })\">自訂欄位管理</a></li></ul></div>");
$templateCache.put("app/user/changePassword/changePassword.html","<div class=row><vms-message data=vm.alert></vms-message><h2>{{ \'change_password\' | translate }}</h2><hr></div><form name=changePassword ng-submit=vm.submit()><div class=\"row-eq-height profile-section\"><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=first-name class=\"control-label col-md-2 col-lg-2\">原密碼</label><div class=\"col-md-8 col-lg-8\"><input type=password class=form-control id=password placeholder=原密碼 ng-model=vm.data.password required></div></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=first-name class=\"control-label col-md-2 col-lg-2\">新密碼</label><div class=\"col-md-8 col-lg-8\"><input type=password name=newPassword ng-class=\"{\'has-error\':changePassword.newPasswordConfirmation.$error.match}\" class=form-control id=newPassword placeholder=新密碼 ng-model=vm.data.newPassword required></div></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=first-name class=\"control-label col-md-2 col-lg-2\">確認新密碼</label><div class=\"col-md-8 col-lg-8\"><input type=password name=newPasswordConfirmation ng-class=\"{\'has-error\':changePassword.newPasswordConfirmation.$error.match}\" class=form-control id=newPasswordConfirmation placeholder=確認新密碼 ng-model=vm.data.newPasswordConfirmation match=vm.data.newPassword minlenght=6 required></div><div class=\"col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2\"><p class=text-danger ng-show=changePassword.newPasswordConfirmation.$error.match>{{ \'alert.danger.password_not_match\' | translate }}</p></div></div></div></div><div class=\"row profile-section\"><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\" type=submit>送出</button></div><div class=col-md-5></div></div></form>");
$templateCache.put("app/user/education/userEducation.html","<div class=profile-section><span class=h2-inline>教育</span> <button class=\"btn btn-default pull-right\" ng-click=vm.setAddEducationVisible()>新增教育</button><hr><div ng-show=vm.isShowAddEducation><form id=new-education class=\"form-inline education-section\"><div class=row><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=school class=\"control-label col-md-2 col-lg-2\">學校名稱</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=school placeholder=學校名稱 ng-model=vm.sEducation.school required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=field-of-study class=\"control-label col-md-4 col-lg-4\">科系</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=field-of-study placeholder=科系 ng-model=vm.sEducation.field_of_study required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=degree class=\"control-label col-md-4 col-lg-4\">學歷</label><div class=\"col-md-8 col-lg-8\"><select class=form-control id=degree placeholder=學歷 ng-model=vm.sEducation.degree ng-options=\"d.value as d.text | translate for d in vm.degrees\" required></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=start-year class=\"control-label col-md-4 col-lg-4\">開始期間</label><div class=\"col-md-8 col-lg-8\"><select name=start-years class=form-control id=start-year placeholder=起始年 ng-model=vm.sEducation.start_year ng-options=\"y.value as y.text for y in vm.years\" required></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=end-year class=\"control-label col-md-4 col-lg-4\">結束期間</label><div class=\"col-md-8 col-lg-8\"><select name=end-year class=form-control id=end-year placeholder=結束年 ng-model=vm.sEducation.end_year ng-options=\"y.value as y.text for y in vm.years\"></select></div></div></div><div class=\"form-group col-md-6 col-sm-6 col-xs-12 col-lg-12\"><div class=row><div class=col-lg-12><button type=button class=\"btn btn-primary\" ng-click=vm.addEducation()>儲存</button> <button type=button class=\"btn btn-default\" ng-click=vm.setAddEducationInvisible()>取消</button></div></div></div></div></form></div><div ng-show=\"vm.educations != undefined && vm.educations.length != 0\"><div ng-repeat=\"(index, education) in vm.educations\"><form editable-form name=vm.education{{education.id}} class=\"form-inline education-section\" onaftersave=vm.updateEducation(education.id) onshow=vm.onShowEditableForm(education.id) onhide=vm.onHideEditableForm(education.id)><div class=row><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=school class=\"control-label col-md-2 col-lg-2\">學校名稱</label><div class=\"col-md-8 col-lg-8\"><a editable-text=\"vm.educations[{{ index }}].school\" e-name=school ng-click=vm.editableFormShow(education.id) e-required>{{ vm.educations[index].school }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=field-of-study class=\"control-label col-md-4 col-lg-4\">科系</label><div class=\"col-md-8 col-lg-8\"><a editable-text=\"vm.educations[{{ index }}].field_of_study\" e-nmae=field-of-study ng-click=vm.editableFormShow(education.id) e-required>{{ vm.educations[index].field_of_study }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=degree class=\"control-label col-md-4 col-lg-4\">學歷</label><div class=\"col-md-8 col-lg-8\"><a editable-select=\"vm.educations[{{ index }}].degree\" e-nmae=degree e-ng-options=\"d.value as d.text | translate for d in vm.degrees\" ng-click=vm.editableFormShow(education.id) e-required>{{ vm.educations[index].degree | educationDegree | translate }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=start-year class=\"control-label col-md-4 col-lg-4\">開始期間</label><div class=\"col-md-8 col-lg-8\"><a editable-select=\"vm.educations[{{ index }}].start_year\" e-ng-options=\"y.value as y.text for y in vm.years\" ng-click=vm.editableFormShow(education.id)>{{ vm.educations[index].start_year }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=end-year class=\"control-label col-md-4 col-lg-4\">結束期間</label><div class=\"col-md-8 col-lg-8\"><a editable-select=\"vm.educations[{{ index }}].end_year\" e-ng-options=\"y.value as y.text for y in vm.years\" ng-click=vm.editableFormShow(education.id)>{{ vm.educations[index].end_year }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-12 col-sm-6 col-xs-12\"><div class=row><div class=col-lg-12 ng-show=vm.editableIsVisible(education.id)><button type=submit class=\"btn btn-primary\">儲存</button> <button type=button class=\"btn btn-default\" ng-click=vm.editableFormCancel(education.id)>取消</button> <a ng-click=vm.deleteEducation(education.id)>刪除</a></div></div></div></div></form></div></div></div>");
$templateCache.put("app/user/experience/userExperience.html","<div class=profile-section><span class=h2-inline>經驗</span> <button class=\"btn btn-default pull-right\" ng-click=vm.setAddExperienceVisible()>新增經驗</button><hr><div ng-show=vm.isShowAddExperience><form id=new-experience class=\"form-inline experience-section\"><div class=row><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=company class=\"control-label col-md-4 col-lg-4\">公司名稱</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=company placeholder=公司名稱 ng-model=vm.sExperience.company required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=job-title class=\"control-label col-md-4 col-lg-4\">工作職稱</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=job-title placeholder=工作職稱 ng-model=vm.sExperience.job_title required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=start-year class=\"control-label col-md-4 col-lg-4\">開始期間</label><div class=\"col-md-8 col-lg-8\"><select name=start-years class=form-control id=start-year placeholder=起始年 ng-model=vm.sExperience.start_year ng-options=\"y.value as y.text for y in vm.years\" required></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=end-year class=\"control-label col-md-4 col-lg-4\">結束期間</label><div class=\"col-md-8 col-lg-8\"><select name=end-year class=form-control id=end-year placeholder=結束年 ng-model=vm.sExperience.end_year ng-options=\"y.value as y.text for y in vm.years\"></select></div></div></div><div class=\"form-group col-md-6 col-sm-6 col-xs-12 col-lg-12\"><div class=row><div class=col-lg-12><button type=button class=\"btn btn-primary\" ng-click=vm.addExperience()>儲存</button> <button type=button class=\"btn btn-default\" ng-click=vm.setAddExperienceInvisible()>取消</button></div></div></div></div></form></div><div ng-show=\"vm.experiences != undefined && vm.experiences.length != 0\"><div ng-repeat=\"(index, experience) in vm.experiences\"><form editable-form name=vm.experience{{experience.id}} class=\"form-inline experience-section\" onaftersave=vm.updateExperience(experience.id) onshow=vm.onShowEditableForm(experience.id) onhide=vm.onHideEditableForm(experience.id)><div class=row><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=company class=\"control-label col-md-4 col-lg-4\">公司名稱</label><div class=\"col-md-8 col-lg-8\"><a editable-text=\"vm.experiences[{{ index }}].company\" e-name=company ng-click=vm.editableFormShow(experience.id) e-required>{{ vm.experiences[index].company }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=job-title class=\"control-label col-md-4 col-lg-4\">工作職稱</label><div class=\"col-md-8 col-lg-8\"><a editable-text=\"vm.experiences[{{ index }}].job_title\" e-nmae=job-title ng-click=vm.editableFormShow(experience.id) e-required>{{ vm.experiences[index].job_title }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=start-year class=\"control-label col-md-4 col-lg-4\">開始期間</label><div class=\"col-md-8 col-lg-8\"><a editable-select=\"vm.experiences[{{ index }}].start_year\" e-ng-options=\"y.value as y.text for y in vm.years\" ng-click=vm.editableFormShow(experience.id)>{{ vm.experiences[index].start_year }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=\"row grid-vertical-align\"><label for=end-year class=\"control-label col-md-4 col-lg-4\">結束期間</label><div class=\"col-md-8 col-lg-8\"><a editable-select=\"vm.experiences[{{ index }}].end_year\" e-ng-options=\"y.value as y.text for y in vm.years\" ng-click=vm.editableFormShow(experience.id)>{{ vm.experiences[index].end_year }}</a></div></div></div><div class=\"form-group col-md-6 col-lg-12 col-sm-6 col-xs-12\"><div class=row><div class=col-lg-12 ng-show=vm.editableIsVisible(experience.id)><button type=submit class=\"btn btn-primary\">儲存</button> <button type=button class=\"btn btn-default\" ng-click=vm.editableFormCancel(experience.id)>取消</button> <a ng-click=vm.deleteExperience(experience.id)>刪除</a></div></div></div></div></form></div></div></div>");
$templateCache.put("app/user/forgotPassword/forgotPassword.html","<div class=\"col-md-8 col-md-offset-2\"><h1 class=text-center>忘記密碼</h1></div><div id=main-content class=\"col-md-8 col-md-offset-2 top-line\"><vms-message data=vm.alert></vms-message><form class=form-horizontal ng-submit=vm.submit()><div class=form-group><label for=email class=\"col-sm-2 control-label\">電子信箱</label><div class=col-sm-10><input type=text class=form-control id=email placeholder=電子信箱 ng-model=vm.data.email required></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=submit class=\"btn btn-primary\">送出</button></div></div></form></div>");
$templateCache.put("app/user/login/userLogin.html","<div id=main-content class=\"col-md-8 col-md-offset-2\"><h1>登入</h1><hr class=hr><vms-message data=vm.alert></vms-message><form class=form-horizontal ng-submit=vm.login()><div class=form-group><label for=username class=\"col-sm-2 control-label\">帳號</label><div class=col-sm-10><input type=text class=form-control id=username placeholder=帳號 ng-model=vm.credentials.username required></div></div><div class=form-group><label for=password class=\"col-sm-2 control-label\">密碼</label><div class=col-sm-10><input type=password class=form-control id=password placeholder=密碼 ng-model=vm.credentials.password required></div></div><div class=form-group><label for=password class=\"col-sm-2 control-label\">選擇身份</label><div class=col-sm-10><label class=radio-inline><input type=radio name=role id=role value=volunteer ng-model=vm.role required> 志工</label><label class=radio-inline><input type=radio name=role id=role value=manager ng-model=vm.role required> 專案管理員</label></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><a class=pull-right ui-sref=forgotPassword>忘記密碼</a></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=submit class=\"btn btn-primary\">登入</button></div></div></form></div>");
$templateCache.put("app/user/register/registerPrivacy.html","<div class=\"col-lg-offset-2 col-lg-8 col-sm-12 col-xs-12\"><h1>隱私權政策</h1><div id=main-content><p class=lead>歡迎您使用 VMS 網站（下稱「本網站」）與相關服務，為了尊重與保護您在本網站上個人資料的隱密性，VMS 將透過這份「VMS 隱私權聲明」（下稱「本聲明」），讓您瞭解VMS 如何透過本網站蒐集、運用與保護您個人的非公示資訊。請您詳細閱讀本聲明，如有任何疑問歡迎您透過 e-mail 與 VMS 聯絡： volunteer.service.tw@gmail.com。</p><p class=text-right>更新日期：2015/10/27</p><hr><h3>個人資料的蒐集方式</h3><p>VMS 透過本網站蒐集個人資料之方式包括：<ol><li>要求您自行輸入個人資料；</li><li>系統自動記錄您瀏覽本網站之歷程</li></ol></p><h3>蒐集的個人資料內容</h3><p>您在本網站註冊新帳號並完成註冊程序後，即成為本網站會員，而您在註冊時需提供的個人資料包括帳號名稱、您的姓名、e-mail 與密碼及其他聯絡方式等。</p><p>註冊完成之後，您可以到「我的資料」填寫、編輯您的個人資訊。您可以自由決定是否填寫這些個人資訊，「我的資料」中的個人資訊並非必填項目。</p><p>若您有加入的外包專案，VMS 將會紀錄您所參與之專案。您亦得在本網站的專案中提供您的個人資料。</p><p>當您瀏覽本網站時，VMS 將以匿名方式蒐集您的操作流程，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄。</p><h3>個人資料之運用</h3><p>為執行本網站相關規定，VMS 可能透過您提供的個人資料與您進行聯絡。</p><p>您的帳號名稱將可讓外包專案中的專案管理員查看，並詢問您是否同意參加專案，除此之外，只要沒有自行將您其他的註冊資料揭露於本網站上，任何使用者均無法瀏覽或利用您的資料。</p><h3>個人聯絡資料之運用</h3><p>本網站將透過電子郵件傳送本網站相關資訊，這些資訊包括但不限於使用者註冊確認信、本聲明與使用條款的修正訊息以、專案邀請、通知信件及本網站活動資訊，但您的電子信箱不會在其他使用者之收件者列表中顯示。</p><h3>線上活動紀錄的運用</h3><p>當您瀏覽本網站，伺服器會自動記錄使用者機器的 IP 位址、使用時間、使用的瀏覽器、瀏覽及點選紀錄等資料，並加以分析。</p><p>本網站僅會針對全體使用者行為之總和進行分析，不會針對您個別之行為進行分析，除非您願意告知您的個人資料，否則 VMS 並不會將此項記錄和您對應。</p><h3>向第三方揭露個人資料</h3><p>若為中華民國相關法令、司法或政府機關要求，或經您的同意，本網站將會揭露您的個人資料，但僅限於向相關之第三人揭露您的個人資料。</p><h3>個人資料之修改</h3><p>當您在本網站註冊後，您可以隨時利用我的資料中之連結，更改（目前尚未提供）、刪除帳號以外您所輸入的任何資料，例如個人姓名、電子信箱、聯絡方式等。 但除了您主動登錄的個人資料之外，您在本網站相關外包專案或事件追蹤系統中所提供之個人資料，不在此修改範圍之內。</p><h3>資料保護措施</h3><p>本網站將會運用安全技術和程序來保護您的個人資料，避免未經您授權的存取、使用或洩露。例如，本網站會將您提供的個人資訊儲存在嚴密控管的設施與電腦設備中，並僅允許少數系統管理者擁有存取權限。</p><p>請妥善保管您的密碼及個人資料，請勿將任何個人資料，尤其是您的密碼提供給任何人，若因此造成任何損失，本不負任何責任。</p><h3>造訪其他網站之注意事項</h3><p>透過本網站所提供的超連結，您可能造訪與本網站相連結之其他網站，這些其他網站也可能蒐集您的個人資料。對於您主動提供的個人資訊，各相連結之其他網站有其個別的隱私權保護政策，其資料處理措施不適用本聲明，本不負任何責任，建議您詳加閱讀這些網站的隱私權保護政策。</p><h3>隱私權聲明更新</h3><p>本網站將不定期更新本聲明，更新時，本網站會同時修訂本聲明的「最後更新日期」。本聲明的重要變更，亦會張貼在本網站上顯著位置，以提醒您注意。</p><hr><button class=\"btn btn-primary btn-lg\" ui-sref=register>同意</button> <button class=\"btn btn-default btn-lg\">不同意</button></div></div>");
$templateCache.put("app/user/register/userRegister.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>註冊</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><vms-message data=vm.alerts></vms-message><form name=register class=form-inline autocomplete=off ng-submit=vm.register()><h2>基本資料</h2><hr><div id=profile-avatar><img id=avatar-image alt=\"Bootstrap Image Preview\" ng-src={{vm.showAvatar}} width=200 class=img-circle> <input id=avatar-input type=file ng-model=vm.avatar onloadend=vm.selectAvatar base-sixty-four-input></div><div id=profile-basic class=\"profile-section row-eq-height\"><div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=username class=\"control-label col-md-3 col-lg-3\">帳號</label><div class=\"col-md-9 col-lg-9\"><input type=text minlength=6 class=form-control id=username placeholder=帳號 ng-model=vm.volunteer.username required></div></div></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=password class=\"control-label col-md-3 col-lg-3\">密碼</label><div class=\"col-md-9 col-lg-9\"><input ng-class=\"{\'has-error\':register.confirmPassowrd.$error.match}\" type=password name=password minlength=6 class=form-control id=password placeholder=密碼 ng-model=vm.volunteer.password required></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><div class=\"col-md-12 col-lg-12\"><!-- <p class=\"text-danger\">...</p> --></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=confirmPassowrd class=\"control-label col-md-3 col-lg-3\">確認密碼</label><div class=\"col-md-9 col-lg-9\"><input ng-class=\"{\'has-error\':register.confirmPassowrd.$error.match}\" type=password match=vm.volunteer.password name=confirmPassowrd ng-model=vm.passwordConfirm minlength=6 class=form-control id=confirm-passowrd placeholder=確認密碼 required></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><div class=\"col-md-12 col-lg-12\"><p class=text-danger ng-show=register.confirmPassowrd.$error.match>{{ \'alert.danger.password_not_match\' | translate }}</p></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=first-name class=\"control-label col-md-3 col-lg-3\">姓氏</label><div class=\"col-md-9 col-lg-9\"><input type=text class=form-control id=first-name placeholder=姓氏 ng-model=vm.volunteer.first_name required></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=last-name class=\"control-label col-md-3 col-lg-3\">名字</label><div class=\"col-md-9 col-lg-9\"><input type=text class=form-control id=last-name placeholder=名字 ng-model=vm.volunteer.last_name required></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=birth-year class=\"control-label col-md-3 col-lg-3\">出生年份</label><div class=\"col-md-9 col-lg-9\"><div class=input-group><input id=birth-year type=text class=form-control uib-datepicker-popup={{vm.datePicker.format}} ng-model=vm.volunteer.birth_year is-open=vm.datePicker.status.opened datepicker-options=vm.datePicker.dateOptions ng-required=true close-text=Close format-year> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.openDatePicker($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=gender class=\"control-label col-md-3 col-lg-3\">性別</label><div class=\"col-md-9 col-lg-9\"><label class=radio-inline><input type=radio name=gender id=gender value=female ng-model=vm.volunteer.gender> 女</label><label class=radio-inline><input type=radio name=gender id=gender value=male ng-model=vm.volunteer.gender> 男</label></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=city class=\"control-label col-md-3 col-lg-3\">縣市</label><div class=\"col-md-9 col-lg-9\"><select class=form-control name=city ng-model=vm.volunteer.city.id ng-options=\"city.id as city.name_zh_tw for city in vm.cities\"></select></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12\"><div class=row><label required-label for=address class=\"control-label col-md-3 col-lg-3\">鄉鎮市區</label><div class=\"col-md-9 col-lg-9\"><input name=address type=text class=form-control id=address placeholder=鄉鎮市區 ng-model=vm.volunteer.location></div></div></div></div><div id=profile-contact class=\"profile-section row\"><h2>聯絡資料</h2><hr><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label required-label for=email class=\"control-label col-md-3 col-lg-3\">電子郵件</label><div class=\"col-md-9 col-lg-9\"><input type=email name=email type=text class=form-control id=email placeholder=電子郵件 ng-model=vm.volunteer.email required></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=phone-number class=\"control-label col-md-3 col-lg-3\">電話號碼</label><div class=\"col-md-9 col-lg-9\"><input name=phone-number type=text class=form-control id=phone-number placeholder=電話號碼 ng-model=vm.volunteer.phone_number></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=emergency-contact class=\"control-label col-md-3 col-lg-3\">緊急聯絡人</label><div class=\"col-md-9 col-lg-9\"><input name=emergency-contact type=text class=form-control id=emergency-contact placeholder=緊急聯絡人 ng-model=vm.volunteer.emergency_contact></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=emergency-contact-phone class=\"control-label col-md-3 col-lg-3\">緊急聯絡人電話</label><div class=\"col-md-9 col-lg-9\"><input name=emergency-contact-phone type=text class=form-control id=emergency-contact-phone placeholder=緊急聯絡人電話 ng-model=vm.volunteer.emergency_phone></div></div></div></div><div class=\"row profile-section\"><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\">送出</button></div><div class=col-md-5></div></div></form></div>");
$templateCache.put("app/user/resetPassword/resetPassword.html","<div class=\"col-md-8 col-md-offset-2\"><h1 class=text-center>重設密碼</h1></div><div id=main-content class=\"col-md-8 col-md-offset-2 top-line\"><vms-message data=vm.alert></vms-message><form name=resetPassword ng-if=vm.showResetForm class=form-horizontal ng-submit=vm.submit()><div class=form-group><label for=password class=\"col-sm-2 control-label\">密碼</label><div class=col-sm-10><input type=password ng-class=\"{\'has-error\':resetPassword.passwordConfirmation.$error.match}\" class=form-control id=password placeholder=密碼 ng-model=vm.data.password minlength=6 required></div></div><div class=form-group><label for=password-confirmation class=\"col-sm-2 control-label\">確認密碼</label><div class=col-sm-10><input type=password name=passwordConfirmation ng-class=\"{\'has-error\':resetPassword.passwordConfirmation.$error.match}\" class=form-control id=password-confirmation placeholder=確認密碼 ng-model=vm.data.passwordConfirmation match=vm.data.password minlength=6 match-required></div></div><div><div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"><p class=text-danger ng-show=resetPassword.passwordConfirmation.$error.match>{{ \'alert.danger.password_not_match\' | translate }}</p></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=submit class=\"btn btn-primary\">送出</button></div></div></form></div>");
$templateCache.put("app/components/customField/preview/customFieldPreview.html","<div class=row><div class=\"col-md-12 col-lg-12\" ng-repeat=\"set in vm.data\"><fill-custom-field-type type=set.type title=set.name metadata=set.metadata></fill-custom-field-type></div></div>");
$templateCache.put("app/project/customField/manage/manageProjectCustomField.html","<span class=h2-inline>自訂欄位管理</span> <span class=\"btn-group pull-right\" role=group><button class=\"btn btn-default\" ng-click=vm.appendCustomField()><span class=\"glyphicon glyphicon-plus\"></span> 新增欄位</button><!-- <button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-ok\"></span> 完成</button> --> <button class=\"btn btn-default\" ng-click=vm.preview(vm.customFields)><span class=\"glyphicon glyphicon-eye-open\"></span> 瀏覽</button></span><hr><vms-message data=vm.alerts></vms-message><div id=poject-custom-fields-section ng-repeat=\"customField in vm.customFields\"><custom-field data=customField></custom-field></div><!--angular ui modal--><script type=text/ng-template id=customFieldPreview.html><div class=\"modal-header\">\n    <h3 class=\"modal-title\">瀏覽</h3>\n</div>\n<div class=\"modal-body\">\n    <custom-field-preview data=\"vm.data\"></custom-field-preview>\n</div></script>");
$templateCache.put("app/project/customField/fill/fillCustomFields.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h2>自訂欄位資料</h2></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=\"alert alert-danger\" role=alert ng-show=vm.errorMsg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>Error:</span> {{ vm.errorMsg }}</div><div class=\"alert alert-info\" role=alert ng-show=vm.msg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>訊息：</span> {{ vm.msg }}</div><form><div id=profile-basic class=\"profile-section row\"><div class=\"col-md-12 col-lg-12\" ng-repeat=\"set in vm.data\"><fill-custom-field-type type=set.type title=set.name field-data=set.custom_field_data.data metadata=set.metadata></fill-custom-field-type></div></div><div class=\"row profile-section\"><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\" ng-click=vm.update()>送出</button></div><div class=col-md-5></div></div></form></div>");
$templateCache.put("app/project/detail/managed/managedProjectDetail.html","<div class=\"alert alert-danger\" role=alert ng-show=vm.errorMsg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>Error:</span> {{ vm.errorMsg }}</div><span class=h2-inline>基本資訊</span> <button class=\"btn btn-default pull-right\" ng-click=vm.attend() ng-show=vm.isGuest()>加入</button> <button class=\"btn btn-default pull-right\" ui-sref=\"fillProjectCustomFieldData({ projectId: vm.project.data.id })\" ng-show=vm.isMember()>填寫資料</button> <button class=\"btn btn-default pull-right\" ui-sref=\"editProject({ id: vm.project.data.id })\" ng-show=vm.isCreator()>編輯</button><hr><div id=project-basic class=\"project-section row\"><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=name class=\"col-md-2 col-lg-4\">名稱</label><div class=\"col-md-10 col-lg-8\"><span id=name>{{ vm.project.name }}</span></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=organization class=\"col-md-2 col-lg-4\">組織名稱</label><div class=\"col-md-10 col-lg-8\"><span id=organization>{{ vm.project.organization }}</span></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=permission class=\"col-md-2 col-lg-4\">權限</label><div class=\"col-md-10 col-lg-8\"><span>{{ vm.project.permission | permissionText | translate }}</span></div></div></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=permission class=\"col-md-2 col-lg-4\">是否發布</label><div class=\"col-md-10 col-lg-8\"><span id=permission aria-label=ABC ng-true-value=true ng-false-value=false>{{ vm.project.is_published | yesNo }}</span></div></div></div><div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=hyperlinks class=\"col-md-1 col-lg-2\">相關連結</label><project-hyperlinks class=\"col-md-11 col-lg-10\" project-id=vm.project.id></project-hyperlinks></div></div><div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=description class=\"col-md-1 col-lg-1\">說明</label><div class=\"col-md-10 col-lg-10\"><div id=description ng-bind-html=\"vm.project.description | htmlize\"></div></div></div></div></div><div class=project-section><span class=h2-inline>專案成員</span> <button class=\"btn btn-default pull-right\" ng-click=vm.manageMembers() ng-show=vm.isCreator()>成員管理</button><hr><div class=row><div ng-repeat=\"member in vm.membersList.data track by $index\"><div class=\"col-md-2 col-lg-3\"><span class=\"glyphicon glyphicon-user\"></span> <a ng-click=vm.showMember(member)>{{ member.attributes.username }}</a></div><!-- <div class=\"col-md-1 col-lg-1\">\n			      {{ member.attributes.first_name }} {{ member.attributes.last_name}}\n			    </div> --></div></div></div>");
$templateCache.put("app/project/detail/public/projectDetail.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>瀏覽專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=\"alert alert-danger\" role=alert ng-show=vm.errorMsg><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> <span class=sr-only>Error:</span> {{ vm.errorMsg }}</div><span class=h3-inline>{{ vm.project.name }}</span> <button class=\"btn btn-default pull-right\" ng-click=vm.attend() ng-show=vm.isGuest()>加入</button> <button class=\"btn btn-default pull-right\" ui-sref=\"fillProjectCustomFieldData({ projectId: vm.project.id })\" ng-show=vm.isMember()>填寫資料</button> <button class=\"btn btn-default pull-right\" ui-sref=\"project.edit({ projectId: vm.project.id })\" ng-show=vm.isCreator()>編輯</button><hr><div id=project-basic class=\"project-section row\"><div class=\"col-md-6 col-lg-6\"><div class=row><div class=\"col-md-4 col-lg-4\"><span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> {{ \'manager\' | translate }}</div><div class=\"col-md-8 col-lg-8\"><p>{{ vm.project.managers.data[0].last_name }} {{ vm.project.managers.data[0].first_name }}</p>({{ vm.project.managers.data[0].email }})</div></div></div><div class=\"col-md-6 col-lg-6\"><div class=row><div class=\"col-md-4 col-lg-4\"><span class=\"glyphicon glyphicon-time\" aria-hidden=true></span> {{ \'created_date\' | translate }}</div><div class=\"col-md-8 col-lg-8\">{{ vm.project.created_at }}</div></div></div><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"col-md-2 col-lg-2\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span> {{ \'description\' | translate }}</div><div class=\"col-md-10 col-lg-10\" ng-bind-html=\"vm.project.description | htmlize\"></div></div></div><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"col-md-2 col-lg-2\"><span class=\"glyphicon glyphicon-link\" aria-hidden=true></span> {{ \'related_links\' | translate }}</div><project-hyperlinks class=\"col-md-10 col-lg-10\" project-id=vm.projectId></project-hyperlinks></div></div><div class=\"col-md-12 col-lg-12\"><div class=row><div class=\"col-md-2 col-lg-2\"><span class=\"fa fa-users\" aira-hidden=true></span> {{ \'project.member\' | translate }}</div><div class=\"col-md-10 col-lg-10\"><div class=row-eq-height><div ng-repeat=\"member in vm.membersList.data track by $index\" class=\"col-md-4 col-lg-4\"><b>{{ member.attributes.first_name }} {{ member.attributes.last_name}} </b>({{ member.attributes.username }})</div></div></div></div></div></div></div>");
$templateCache.put("app/project/list/all/allProjectList.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>所有專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=\"alert alert-info\" role=alert>參與您有興趣的專案！</div><div id=search-section class=row-eq-height><div class=\"col-md-7 col-lg-7\"><div class=row><div class=\"col-md-2 col-lg-2\" uib-dropdown><button type=button class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle>{{ \'field\' | translate }} <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu><li><a ng-click=\"vm.setSearchField(\'name\')\">{{ \'project.search.fields.name\' | translate }}</a></li><li><a ng-click=\"vm.setSearchField(\'organization\')\">{{ \'project.search.fields.organization\' | translate }}</a></li></ul></div><div class=\"col-md-8 col-lg-8\"><div class=input-group><span class=input-group-addon>{{ \'project.search.fields.\' + vm.searchField | translate }}</span> <input class=form-control ng-model=vm.searchProject[vm.searchField] type=text name=search id=search placeholder=\"{{ \'search_keyword\' | translate }}\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=row><div class=\"col-md-12 col-xs-12 col-sm-12\"><div class=\"row project-item\" ng-repeat=\"project in vm.projects | filter: vm.searchProject\"><div class=col-md-8><div class=row><div class=col-md-12><h4><a ui-sref=\"projectDetail({ id: project.id })\">{{ project.name }}</a></h4></div><div class=col-md-6>{{ project.organization }}</div><div class=col-md-6>{{ project.updated_at }}</div></div></div><div class=col-md-4><div class=row><div class=\"col-md-12 text-right\"><span class=\"fa fa-user fa-lg\" aria-hidden=true></span> {{ project.member_number }}</div><div class=\"col-md-12 text-right\"><span class=\"fa fa-cubes fa-lg\" aria-hidden=true></span> {{ project.process_number }}</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/project/list/attending/attendingProjectList.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>已參與的專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><table class=\"table table-striped\"><thead><tr><th>專案名稱</th><th>組織名稱</th><th>填寫您的資料</th><th>離開</th></tr></thead><tbody><tr ng-repeat=\"project in vm.projects.data\"><td><a ui-sref=\"projectDetail({ id: project.id })\">{{ project.attributes.name }}</a></td><td>{{ project.attributes.organization }}</td><td><span class=\"glyphicon glyphicon-edit\" ui-sref=\"fillProjectCustomFieldData({ projectId: project.id })\" aria-hidden=true></span></td><td><span ui-sref=\"editProject({ id: project.id })\" aria-hidden=true>離開</span></td></tr></tbody></table></div>");
$templateCache.put("app/project/list/managed/managedProjectList.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>我的專案</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div id=search-section class=row-eq-height><div class=\"col-md-6 col-lg-6\"><form class=form-inline><div class=form-group><label>{{ \'search\' | translate }}</label><input class=form-control ng-model=vm.searchProjectName.name type=text name=search id=search placeholder=\"{{ \'enter_project_name\' | translate }}\"></div></form></div><div class=\"col-md-2 col-md-offset-4 col-lg-2 col-lg-offset-4\"><button class=\"btn btn-primary\" role=button ui-sref=createProject>新增專案</button></div></div><table class=\"table table-striped\"><thead><tr><th>專案名稱</th><th>組織名稱</th><th>是否發布</th><th>建立時間</th><th>管理</th><th>刪除</th></tr></thead><tbody><tr ng-repeat=\"project in vm.projects | filter: vm.searchProjectName\"><td><a ui-sref=\"projectDetail({ id: project.id })\">{{ project.name }}</a></td><td>{{ project.organization }}</td><td>{{ project.is_published | yesNo }}</td><td>{{ project.created_at | formatDateTime }}</td><td><span class=\"glyphicon glyphicon-cog\" ui-sref=\"project.show({ projectId: project.id })\" aria-hidden=true></span></td><td><span class=\"glyphicon glyphicon-trash\" ng-click=vm.delete(project.id) aria-hidden=true></span></td></tr></tbody></table></div><!--angular ui modal--><script type=text/ng-template id=deleteProject.html><div class=\"modal-header\">\n    <h3 class=\"modal-title\">注意！您的專案即將被刪除</h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"alert alert-danger\" role=\"alter\" ng-show=\"vm.deleteMsg\">{{vm.deleteMsg}}</div>\n    <div class=\"alert alert-warning\" role=\"alert\">{{vm.remind}}</div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ok()\">確認刪除專案</button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">取消</button>\n</div></script>");
$templateCache.put("app/project/member/list/projectMemberList.html","<span class=h2-inline>成員管理</span><!-- <div ng-repeat=\"item in vm.memberCustomFieldDataList track by $index\" class=\"row\">\n	<div class=\"col-md-12 col-lg-12\" ng-show=\"item\">\n		<h4> <span class=\"glyphicon glyphicon-user\"></span> 成員：{{ vm.getIncludedMember($index).first_name }}{{ vm.getIncludedMember($index).last_name }} ({{ vm.getIncludedMember($index).username }})</h4>\n	</div>\n	<div class=\"col-md-12 col-lg-12\">\n		<p class=\"text-muted\">\n			{{ vm.getIncludedMember($index).attending_at.date | date:\'yyyy-MM-dd HH:mm\' }}\n		</p>\n	</div>\n	<div class=\"col-md-12 col-lg-12\" ng-show=\"item\">\n		<fill-custom-field-type type=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).type\" title=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).name\" field-data=\"value.attributes.data\" metadata=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).metadata\"></fill-custom-field-type>\n		<table class=\"table\">\n			<thead>\n				<tr>\n					<th class=\"col-md-2\">\n						欄位名稱\n					</th>\n					<th class=\"col-md-2\">\n						內容\n					</th>\n				</tr>\n			</thead>\n			<tbody>\n				<tr ng-repeat=\"value in item\">\n					<th class=\"col-md-2\">\n						{{ vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).name }}\n					</th>\n					<td class=\"col-md-10\">\n						{{ value.attributes.data | customFieldDataToText: vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).type:vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).metadata}}\n					</td>\n				</tr>\n			</tbody>\n		</table>\n	</div>\n</div> --><div ng-repeat=\"member in vm.members\" class=row><div class=\"col-md-12 col-lg-12\" ng-show=member><h4><span class=\"glyphicon glyphicon-user\"></span> 成員：{{ member.first_name }}{{ member.last_name }} ({{ member.username }})</h4></div><div class=\"col-md-12 col-lg-12\"><p class=text-muted>{{ member.attending_at.date | date:\'yyyy-MM-dd HH:mm\' }}</p></div><div class=\"col-md-12 col-lg-12\" ng-show=member><!-- <fill-custom-field-type type=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).type\" title=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).name\" field-data=\"value.attributes.data\" metadata=\"vm.getIncludedCustomField(value.relationships.project_custom_field.data.id).metadata\"></fill-custom-field-type> --><table class=table><thead><tr><th class=col-md-2>欄位名稱</th><th class=col-md-2>內容</th></tr></thead><tbody><tr ng-repeat=\"customFieldData in member.custom_field_data\"><th class=col-md-2>{{ vm.getCustomFieldById(customFieldData.project_custom_field.data.id).name }}</th><td class=col-md-10>{{ customFieldData.data | customFieldDataToText: vm.getCustomFieldById(customFieldData.project_custom_field.data.id).type:vm.getCustomFieldById(customFieldData.project_custom_field.data.id).metadata}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/user/email/verify/verifyUserEmail.html","<div class=\"col-md-8 col-md-offset-2\"><h1 class=text-center>驗證您的電子信箱</h1></div><div id=main-content class=\"col-md-8 col-md-offset-2\"><div class=email-verification ng-show=vm.verification><p class=lead>請稍候，目前正在進行驗證...</p></div><div class=email-verification-success ng-show=vm.verificationSuccess><p class=lead>{{vm.volunteer.email}} 電子信箱已經通過驗證</p></div><div class=email-verification-success ng-hide=vm.verificationStatus><p class=lead>{{vm.volunteer.email}} 電子信箱無法驗證</p><!--<button class=\"btn btn-primary btn-lg\">重新驗證</button>--></div></div>");
$templateCache.put("app/user/profile/update/updateAboutAndContact.html","<div class=row><vms-message data=vm.alert></vms-message><h2>關於</h2><hr><div class=\"col-lg-12 col-md-12\"><div id=profile-avatar class=pull-left><img ng-src={{vm.profile.avatar_url}} id=profile-avatar width=200 class=\"img-responsive img-circle center-block\"> <input id=avatar-input type=file ng-model=vm.avatar onloadend=vm.selectAvatar base-sixty-four-input></div></div></div><form><div class=\"row-eq-height profile-section\"><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=first-name class=\"control-label col-md-4 col-lg-4\">姓氏</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=first-name placeholder=姓氏 ng-model=vm.profile.first_name required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=last-name class=\"control-label col-md-4 col-lg-4\">名字</label><div class=\"col-md-8 col-lg-8\"><input type=text class=form-control id=first-name placeholder=名字 ng-model=vm.profile.last_name required></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=birth-year class=\"control-label col-md-4 col-lg-4\">出生年份</label><div class=\"col-md-8 col-lg-8\"><div class=input-group><input id=birth-year type=text class=form-control uib-datepicker-popup={{vm.datePicker.format}} ng-model=vm.profile.birth_year is-open=vm.datePicker.status.opened datepicker-options=vm.datePicker.dateOptions ng-required=true close-text=Close> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.openDatePicker($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=gender class=\"control-label col-md-4 col-lg-4\">性別</label><div class=\"col-md-8 col-lg-8\"><label class=radio-inline><input type=radio name=gender id=gender value=female ng-model=vm.profile.gender> 女</label><label class=radio-inline><input type=radio name=gender id=gender value=male ng-model=vm.profile.gender> 男</label></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=city class=\"control-label col-md-4 col-lg-4\">縣市</label><div class=\"col-md-8 col-lg-8\"><select class=form-control name=city ng-model=vm.profile.city.id ng-options=\"city.id as city.name_zh_tw for city in vm.cities\"></select></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=location class=\"control-label col-md-4 col-lg-4\">鄉鎮市區</label><div class=\"col-md-8 col-lg-8\"><input name=location type=text class=form-control id=location placeholder=地址 ng-model=vm.profile.location></div></div></div><div class=\"form-group col-md-12 col-lg-12 col-sm-12 col-xs-12\"><div class=row><label for=profile-introduction class=\"control-label col-md-2 col-lg-2\">介紹</label><div class=\"col-md-10 col-lg-10\"><textarea name=p-introduction type=text class=form-control id=p-introduction placeholder=介紹 rows=3 ng-model=vm.profile.introduction>\n					</textarea></div></div></div></div><div class=\"row profile-section\"><h2>聯絡資訊</h2><hr><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=phone-number class=\"control-label col-md-4 col-lg-4\">電話號碼</label><div class=\"col-md-8 col-lg-8\"><input name=phone-number type=text class=form-control id=phone-number placeholder=電話號碼 ng-model=vm.profile.phone_number></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=emergency-contact class=\"control-label col-md-4 col-lg-4\">緊急聯絡人</label><div class=\"col-md-8 col-lg-8\"><input name=emergency-contact type=text class=form-control id=emergency-contact placeholder=緊急聯絡人 ng-model=vm.profile.emergency_contact></div></div></div><div class=\"form-group col-md-6 col-lg-6 col-sm-6 col-xs-12\"><div class=row><label for=emergency-contact-phone class=\"control-label col-md-4 col-lg-4\">緊急聯絡人電話</label><div class=\"col-md-8 col-lg-8\"><input name=emergency-contact-phone type=text class=form-control id=emergency-contact-phone placeholder=緊急聯絡人電話 ng-model=vm.profile.emergency_phone></div></div></div></div><div class=\"row profile-section\"><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-primary btn-lg\" ng-click=vm.updateAboutAndContact()>送出</button></div><div class=col-md-5></div></div></form>");
$templateCache.put("app/user/profile/update/updateUserProfile.html","<div class=\"col-xs-12 col-sm-10 col-sm-offset-1\"><h1>編輯我的資料</h1></div><div id=main-content class=\"top-line col-xs-12 col-sm-10 col-sm-offset-1\"><div class=row><div class=col-md-3><div class=\"panel panel-default\"><div class=panel-heading><b>個人資料</b></div><ul class=list-group><li class=list-group-item><a ui-sref=rootEditProfile.aboutContact>關於我與聯絡</a></li><li class=list-group-item><a ui-sref=rootEditProfile.experienceEducation>經驗與教育</a></li><li class=list-group-item><a ui-sref=rootEditProfile.skillEquipment>技能與裝備</a></li><li class=list-group-item><a ui-sref=rootEditProfile.changePassword>{{ \'change_password\' | translate }}</a></li></ul></div></div><div class=col-md-9><div class=\"anim-in-out anim-fade\" data-anim-speed=1000 ui-view=profileContent></div></div></div></div>");
$templateCache.put("app/user/profile/show/showUserProfile.html","<div class=\"col-xs-12 col-md-3 col-sm-3\" id=profile-introduction><img ng-src={{vm.profile.avatar_url}} id=profile-avatar width=300 class=\"img-responsive img-circle center-block\"><h3 class=text-center>{{vm.profile.last_name +\" \"+ vm.profile.first_name}}</h3><p id=profile-self-introduction>{{vm.profile.introduction}}</p><div class=row id=profile-participate><div class=\"col-xs-12 col-sm-12\"><div class=row><div class=\"col-sm-7 col-xs-6\"><span>參與中的</span></div><div class=\"col-sm-5 col-xs-6\"><span class=\"pull-right label label-primary\">{{vm.profile.processes.participating_number}}</span></div></div></div><!-- <div class=\"col-sm-12 col-xs-12\">\n            <div class=\"row\">\n                <div class=\"col-sm-7 col-xs-6\">\n                    <span>曾參與過的</span>\n                </div>\n                <div class=\"col-sm-5 col-xs-6\">\n                    <span class=\"pull-right label label-primary\">{{vm.profile.processes.participated_number}}</span>\n                </div>\n            </div>\n        </div> --></div><button class=\"btn btn-danger center-block\" ng-click=vm.open()>刪除帳號</button></div><div class=\"col-xs-12 col-md-9 col-sm-9\" id=profile-main><div id=profile-container><div ng-init=\"tab = 1\"><ul class=\"nav nav-tabs\" id=profile-right-navbar><li ng-class=\"{active:tab===1}\"><a href ng-click=\"tab=1\">個人資料</a></li><!-- <li ng-class=\"{active:tab===2}\"><a href ng-click=\"tab=2\">Projects</a></li> --></ul></div><div id=main-profile class=panel ng-show=\"tab===1\"><div id=profile-about><div class=\"row profile-header\"><div class=\"col-md-4 col-lg-4 col-xs-12\"><h3 class=\"glyphicon glyphicon-user\" aria-hidden=true>我的資料</h3></div><div class=\"col-md-12 col-xs-12\"><button type=button class=\"btn btn-primary pull-right\" ui-sref=rootEditProfile.edit><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span> 編輯</button></div></div><div class=\"row profile-content\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">姓氏 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.first_name}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">名字 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.last_name}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">帳號 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.username}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">出生年份 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.birth_year | date : \'yyyy\'}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">性別 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.gender | translate}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">縣市 </span><span class=\"col-sm-7 col-xs-7\">{{ vm.profile.city.name_en }}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-12\">鄉鎮市區 </span><span class=\"col-sm-7 col-xs-12\">{{vm.profile.location}}</span></div></div></div></div><hr><div id=profile-contact><div class=\"row profile-header\"><div class=\"col-md-4 col-lg-3 col-sm-12\"><h3 class=\"glyphicon glyphicon-phone-alt\" aria-hidden=true>聯絡資訊</h3></div></div><div class=\"row profile-content\"><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>電話號碼 </span><span class=col-sm-8>{{vm.profile.phone_number}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>電子郵件 </span><span class=col-sm-8>{{vm.profile.email}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>緊急聯絡人 </span><span class=col-sm-8>{{vm.profile.emergency_contact}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>緊急聯絡電話 </span><span class=col-sm-8>{{vm.profile.emergency_phone}}</span></div></div></div></div><hr><!--            <div ui-view=\"profileEducation\" ng-include=\"\'/app/volunteer-rofile/volunteer-experience-education.html\'\"></div>\n            <hr>\n            <div ui-view=\"profileSkillEquipment\" ng-include=\"\'/app/volunteer-profile/volunteer-skill-equipment.html\'\"></div> --></div><div class=panel ng-show=\"tab===2\"><div ng-include src=\"\'/app/volunteerProfile/volunteer-projects.html\'\"></div></div></div></div><!--angular ui modal--><script type=text/ng-template id=myModalContent.html><div class=\"modal-header\">\n    <h3 class=\"modal-title\">注意！您的帳號即將被刪除</h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"alert alert-danger\" role=\"alter\" ng-show=\"vm.deleteMsg\">{{vm.deleteMsg}}</div>\n    <div class=\"alert alert-warning\" role=\"alert\">{{vm.remind}}</div>\n    <div class=\"form-group\">\n        <label for=\"password\" class=\"control-label\">請輸入您的密碼：</label>\n        <input type=\"password\" id=\"password\" class=\"form-control\" ng-model=\"vm.password\" placeholder=\"輸入您的密碼\">\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ok()\">確認刪除帳號</button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">取消</button>\n</div></script>");
$templateCache.put("app/user/profile/show/userAbout.html","<div class=\"row profile-header\"><div class=\"col-md-3 col-xs-12\"><h3 class=\"glyphicon glyphicon-user\" aria-hidden=true>關於</h3></div><div class=\"col-md-9 col-xs-12\"><button type=button class=\"btn btn-primary pull-right\" ui-sref=editProfile><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span> 編輯</button></div></div><div class=\"row profile-content\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">姓氏 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.first_name}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">名字 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.last_name}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">帳號 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.username}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">出生年份 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.birth_year}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">性別 </span><span class=\"col-sm-7 col-xs-7\">{{vm.profile.gender}}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-5\">縣市 </span><span class=\"col-sm-7 col-xs-7\">{{ vm.profile.city.name_zh_tw }}</span></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=row><span class=\"col-sm-5 col-xs-12\">鄉鎮市區 </span><span class=\"col-sm-7 col-xs-12\">{{vm.profile.location}}</span></div></div></div>");
$templateCache.put("app/user/profile/show/userContact.html","<div class=\"row profile-header\"><div class=col-md-3><h3 class=\"glyphicon glyphicon-phone-alt\" aria-hidden=true>聯絡資訊</h3></div></div><div class=\"row profile-content\"><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>電話號碼 </span><span class=col-sm-8>{{vm.profile.phone_number}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>電子郵件 </span><span class=col-sm-8>{{vm.profile.email}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>緊急聯絡人 </span><span class=col-sm-8>{{vm.profile.emergency_contact}}</span></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><span class=col-sm-4>緊急聯絡電話 </span><span class=col-sm-8>{{vm.profile.emergency_phone}}</span></div></div></div>");
$templateCache.put("app/user/profile/show/userExperienceEducation.html","<div class=row><div class=\"col-md-6 col-sm-6\"><div class=row><div class=\"col-md-12 profile-header\"><h3 class=\"glyphicon glyphicon-file\" aria-hidden=true>經歷</h3></div><div class=profile-content-list ng-repeat=\"(id, experience) in vm.profile.experience\"><div id=profile-experience-{{id}} class=profile-content-item><span class=col-sm-12>{{experience.name}} </span><span class=col-sm-12>{{experience.job_title}} </span><span class=col-sm-12>{{experience.start_year}} ~ {{experience.end_year}}</span></div></div></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><div class=\"col-md-12 profile-header\"><h3 class=\"glyphicon glyphicon-education\" aria-hidden=true>學歷</h3></div><div class=profile-content-list ng-repeat=\"(id, education) in vm.profile.education\"><div id=profile-education-{{id}} class=profile-content-item><span class=col-sm-12>{{education.field_of_study}} </span><span class=col-sm-12>{{education.school}} </span><span class=col-sm-12>{{education.start_year}} ~ {{education.end_year}}</span></div></div></div></div></div>");
$templateCache.put("app/user/profile/show/userProjects.html","<div class=\"row profile-right-padding\"><h3>Projects you\'re in</h3><div class=table-responsive><table class=table><thead><tr class=profile-project-tableHead><th>#</th><th>Project Name</th><th>Manager</th><th>Details</th><th>Cancel</th></tr></thead><tbody><tr ng-repeat=\"project in vm.projects\"><td>{{project.Id}}</td><td>{{project.ProjectName}}</td><td>{{project.Manager}}</td><td><a href=# class=profile-project-a>View</a></td><td><a href=#><span class=\"glyphicon glyphicon-share\" aria-hidden=true></span></a></td></tr></tbody></table></div><h3>Invites</h3><div class=table-responsive><table class=table><thead><tr class=profile-project-tableHead><th>#</th><th>Project Name</th><th>Manager</th><th>Details</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"invite in vm.invites\"><td>{{invite.Id}}</td><td>{{invite.ProjectName}}</td><td>{{invite.Manager}}</td><td><a href=# class=profile-project-a>View</a></td><td><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown>Choose <span class=caret></span></button><!-- <ul class=\"dropdown-menu\" ng-repeat=\"select in vm.choose\">\n                            <li><a href=\"#\">select</a></li>\n                        </ul> --></td></tr></tbody></table></div></div>");
$templateCache.put("app/user/profile/show/userSkillEquipment.html","<div class=row><div class=\"col-md-6 col-sm-6\"><div class=row><div class=\"col-md-12 profile-header\"><h3 class=\"glyphicon glyphicon-certificate\" aria-hidden=true>技能</h3></div><div class=profile-content-list><div id=profile-skills class=profile-content-item><span class=col-sm-12><span ng-repeat=\"skill in vm.profile.skills\">{{skill.name}}&nbsp;</span></span></div></div></div></div><div class=\"col-md-6 col-sm-6\"><div class=row><div class=\"col-md-12 profile-header\"><h3 class=\"glyphicon glyphicon-wrench\" aria-hidden=true>器材/設備</h3></div><div class=profile-content-list><div id=profile-equipment class=profile-content-item><span class=col-sm-12><span ng-repeat=\"equipment in vm.profile.equipment\">{{equipment.name}}&nbsp;</span></span></div></div></div></div></div>");
$templateCache.put("app/user/register/success/userRegisterSuccess.html","<div class=\"col-md-8 col-md-offset-2\"><h1 class=text-center>完成註冊</h1></div><div id=main-content class=\"col-md-8 col-md-offset-2 top-line\"><p class=lead>{{ vm.volunteer.last_name }} 您好，為了完成註冊，身份驗證確認信件會寄到您的 {{ vm.volunteer.email }} 信箱。</p><p class=lead>您可以點擊信件中的連結完成身份驗證。</p><!--<p class=\"lead\">如果您許久未收到註冊信件，請點擊下方連結請求重送身份驗證信件。</p>\n  <button class=\"btn btn-primary btn-lg\" ui-sref=\"register\">重送</button>--></div>");
$templateCache.put("app/user/skillEquipment/edit/userEditSkillEquipment.html","<div class=\"row profile-section\"><h2>技能</h2><hr><form><div class=\"col-lg-12 col-mg-12\"><tags-input class=bootstrap ng-model=vm.skills min-length=1 display-property=name placeholder=\"{{ \'placeholder.add_a_new_skill\' | translate }}\" replace-spaces-with-dashes=false><auto-complete source=vm.refreshSkillCandidatedKeywords($query) min-length=1 debounce-delay=1000 max-results=10 display-property=name></auto-complete></tags-input></div><div class=\"col-lg-12 col-mg-12\"><button type=submit ng-click=vm.updateSkills() class=\"btn btn-primary\">儲存</button></div></form></div><div class=\"row profile-section\"><h2>裝備</h2><hr><form><div class=\"col-lg-12 col-mg-12\"><tags-input class=bootstrap ng-model=vm.equipment min-length=1 display-property=name placeholder=\"{{ \'placeholder.add_a_new_equipment\' | translate }}\" replace-spaces-with-dashes=false><auto-complete source=vm.refreshEquipmentCandidateKeywords($query) min-length=1 debounce-delay=1000 max-results=10 display-property=name></auto-complete></tags-input></div><div class=\"col-lg-12 col-mg-12\"><button type=submit ng-click=vm.updateEquipment() class=\"btn btn-primary\">儲存</button></div></form></div>");}]);